const AllGeneListMatch = {
    "AACS": [
        "AACS_530K"
    ],
    "AARS1": [
        "AARS1_564K",
        "AARS1_81K"
    ],
    "AASDH": [
        "AASDH_544K"
    ],
    "AATF": [
        "AATF_383K"
    ],
    "ABAT": [
        "ABAT_318K"
    ],
    "ABCB7": [
        "ABCB7_361K",
        "ABCB7_511K"
    ],
    "ABCE1": [
        "ABCE1_343K",
        "ABCE1_397K",
        "ABCE1_419K"
    ],
    "ABCF1": [
        "ABCF1_347K"
    ],
    "ABCF2": [
        "ABCF2_315K"
    ],
    "ABCG2": [
        "ABCG2_49K"
    ],
    "ACAA2": [
        "ACAA2_137K"
    ],
    "ACACA": [
        "ACACA_741K"
    ],
    "ACADL": [
        "ACADL_322K"
    ],
    "ACADVL": [
        "ACADVL_195K"
    ],
    "ACAT1": [
        "ACAT1_263K",
        "ACAT1_268K"
    ],
    "ACIN1": [
        "ACIN1_717K"
    ],
    "ACLY": [
        "ACLY_1080K",
        "ACLY_167K",
        "ACLY_272K",
        "ACLY_488K",
        "ACLY_978K"
    ],
    "ACO2": [
        "ACO2_309K",
        "ACO2_411K",
        "ACO2_689K"
    ],
    "ACOT7": [
        "ACOT7_362K"
    ],
    "ACOT9": [
        "ACOT9_294K"
    ],
    "ACOX1": [
        "ACOX1_437K",
        "ACOX1_500K",
        "ACOX1_643K",
        "ACOX1_651K"
    ],
    "ACP1": [
        "ACP1_113K"
    ],
    "ACSF2": [
        "ACSF2_182K",
        "ACSF2_510K"
    ],
    "ACSL3": [
        "ACSL3_706K"
    ],
    "ACSS3": [
        "ACSS3_524K",
        "ACSS3_97K"
    ],
    "ACTG1": [
        "ACTG1_113K",
        "ACTG1_328K",
        "ACTG1_50K",
        "ACTG1_61K"
    ],
    "ACTN1": [
        "ACTN1_35K",
        "ACTN1_436K",
        "ACTN1_676K"
    ],
    "ACTR2": [
        "ACTR2_368K",
        "ACTR2_46K"
    ],
    "ADH5": [
        "ADH5_107K",
        "ADH5_366K"
    ],
    "ADIRF": [
        "ADIRF_4K"
    ],
    "ADK": [
        "ADK_162K",
        "ADK_61K",
        "ADK_71K"
    ],
    "ADNP": [
        "ADNP_606K"
    ],
    "ADSS2": [
        "ADSS2_118K",
        "ADSS2_173K",
        "ADSS2_196K",
        "ADSS2_447K"
    ],
    "AFDN": [
        "AFDN_1237K"
    ],
    "AFG3L2": [
        "AFG3L2_601K"
    ],
    "AFP": [
        "AFP_249K"
    ],
    "AGO2": [
        "AGO2_726K"
    ],
    "AHCY": [
        "AHCY_186K",
        "AHCY_188K",
        "AHCY_408K",
        "AHCY_426K"
    ],
    "AHCYL1": [
        "AHCYL1_108K",
        "AHCYL1_267K",
        "AHCYL1_478K"
    ],
    "AHNAK": [
        "AHNAK_1280K",
        "AHNAK_134K",
        "AHNAK_1408K",
        "AHNAK_1594K",
        "AHNAK_2132K",
        "AHNAK_2603K",
        "AHNAK_3106K",
        "AHNAK_3303K",
        "AHNAK_3363K",
        "AHNAK_3913K",
        "AHNAK_4985K",
        "AHNAK_563K",
        "AHNAK_5831K"
    ],
    "AHSA1": [
        "AHSA1_94K"
    ],
    "AK2": [
        "AK2_147K",
        "AK2_28K"
    ],
    "AK3": [
        "AK3_20K"
    ],
    "AK4": [
        "AK4_186K"
    ],
    "AKAP1": [
        "AKAP1_160K"
    ],
    "AKAP8": [
        "AKAP8_407K"
    ],
    "AKR1A1": [
        "AKR1A1_263K",
        "AKR1A1_85K"
    ],
    "AKR1C3": [
        "AKR1C3_161K",
        "AKR1C3_270K",
        "AKR1C3_4K"
    ],
    "AKR1D1": [
        "AKR1D1_71K"
    ],
    "AKR7A2": [
        "AKR7A2_105K"
    ],
    "ALDH16A1": [
        "ALDH16A1_114K"
    ],
    "ALDH18A1": [
        "ALDH18A1_767K"
    ],
    "ALDH1L2": [
        "ALDH1L2_681K"
    ],
    "ALDH2": [
        "ALDH2_378K",
        "ALDH2_428K"
    ],
    "ALDH6A1": [
        "ALDH6A1_76K"
    ],
    "ALDH9A1": [
        "ALDH9A1_68K"
    ],
    "ALDOA": [
        "ALDOA_13K",
        "ALDOA_147K",
        "ALDOA_14K",
        "ALDOA_312K",
        "ALDOA_330K",
        "ALDOA_42K",
        "ALDOA_99K"
    ],
    "ALG5": [
        "ALG5_139K"
    ],
    "ALMS1": [
        "ALMS1_3058K"
    ],
    "ALS2": [
        "ALS2_533K"
    ],
    "AMPD2": [
        "AMPD2_812K"
    ],
    "ANKFY1": [
        "ANKFY1_217K",
        "ANKFY1_937K"
    ],
    "ANKRD54": [
        "ANKRD54_217K"
    ],
    "ANP32B": [
        "ANP32B_28K"
    ],
    "ANP32E": [
        "ANP32E_113K"
    ],
    "ANXA11": [
        "ANXA11_255K",
        "ANXA11_430K"
    ],
    "ANXA2": [
        "ANXA2_152K",
        "ANXA2_204K",
        "ANXA2_324K"
    ],
    "ANXA4": [
        "ANXA4_246K",
        "ANXA4_293K",
        "ANXA4_57K"
    ],
    "ANXA5": [
        "ANXA5_97K"
    ],
    "ANXA6": [
        "ANXA6_265K",
        "ANXA6_299K",
        "ANXA6_306K",
        "ANXA6_370K",
        "ANXA6_406K",
        "ANXA6_63K"
    ],
    "ANXA7": [
        "ANXA7_228K"
    ],
    "AP1B1": [
        "AP1B1_318K"
    ],
    "AP1G1": [
        "AP1G1_147K"
    ],
    "AP1M1": [
        "AP1M1_237K",
        "AP1M1_326K"
    ],
    "AP2A1": [
        "AP2A1_177K"
    ],
    "AP2A2": [
        "AP2A2_117K"
    ],
    "AP2M1": [
        "AP2M1_203K",
        "AP2M1_308K"
    ],
    "AP2S1": [
        "AP2S1_45K"
    ],
    "AP3B1": [
        "AP3B1_337K",
        "AP3B1_481K",
        "AP3B1_90K"
    ],
    "AP3D1": [
        "AP3D1_1026K",
        "AP3D1_336K",
        "AP3D1_820K"
    ],
    "AP3S1": [
        "AP3S1_166K"
    ],
    "AP3S2": [
        "AP3S2_166K"
    ],
    "APBB2": [
        "APBB2_242K"
    ],
    "APEX1": [
        "APEX1_197K",
        "APEX1_276K"
    ],
    "API5": [
        "API5_202K",
        "API5_398K"
    ],
    "APPL1": [
        "APPL1_289K"
    ],
    "APRT": [
        "APRT_114K",
        "APRT_51K"
    ],
    "ARCN1": [
        "ARCN1_243K"
    ],
    "ARFGAP1": [
        "ARFGAP1_285K"
    ],
    "ARFGEF1": [
        "ARFGEF1_71K"
    ],
    "ARHGAP1": [
        "ARHGAP1_48K"
    ],
    "ARHGAP35": [
        "ARHGAP35_35K"
    ],
    "ARHGAP5": [
        "ARHGAP5_321K"
    ],
    "ARHGDIA": [
        "ARHGDIA_141K",
        "ARHGDIA_43K",
        "ARHGDIA_52K"
    ],
    "ARHGEF7": [
        "ARHGEF7_725K"
    ],
    "ARID1A": [
        "ARID1A_1819K",
        "ARID1A_1880K",
        "ARID1A_1928K"
    ],
    "ARID1B": [
        "ARID1B_1898K"
    ],
    "ARL6IP1": [
        "ARL6IP1_114K"
    ],
    "ARMT1": [
        "ARMT1_40K",
        "ARMT1_46K"
    ],
    "ARPC2": [
        "ARPC2_259K",
        "ARPC2_269K"
    ],
    "ARPC3": [
        "ARPC3_56K",
        "ARPC3_61K"
    ],
    "ARPC5": [
        "ARPC5_3K",
        "ARPC5_67K"
    ],
    "ARPC5L": [
        "ARPC5L_69K"
    ],
    "ASCC3": [
        "ASCC3_572K"
    ],
    "ASH1L": [
        "ASH1L_2287K"
    ],
    "ASH2L": [
        "ASH2L_294K"
    ],
    "ASNS": [
        "ASNS_168K",
        "ASNS_511K",
        "ASNS_556K"
    ],
    "ASS1": [
        "ASS1_340K"
    ],
    "ATAD1": [
        "ATAD1_274K"
    ],
    "ATAD2": [
        "ATAD2_772K"
    ],
    "ATAD3A": [
        "ATAD3A_231K"
    ],
    "ATF7IP": [
        "ATF7IP_938K"
    ],
    "ATG3": [
        "ATG3_185K",
        "ATG3_77K"
    ],
    "ATIC": [
        "ATIC_137K",
        "ATIC_406K",
        "ATIC_66K"
    ],
    "ATM": [
        "ATM_2440K"
    ],
    "ATOX1": [
        "ATOX1_38K",
        "ATOX1_57K"
    ],
    "ATP1B1": [
        "ATP1B1_216K"
    ],
    "ATP2B1": [
        "ATP2B1_64K"
    ],
    "ATP5F1A": [
        "ATP5F1A_161K",
        "ATP5F1A_218K"
    ],
    "ATP5F1B": [
        "ATP5F1B_201K"
    ],
    "ATP5F1C": [
        "ATP5F1C_115K",
        "ATP5F1C_39K",
        "ATP5F1C_90K"
    ],
    "ATP5F1E": [
        "ATP5F1E_21K"
    ],
    "ATP5IF1": [
        "ATP5IF1_72K"
    ],
    "ATP5PF": [
        "ATP5PF_99K"
    ],
    "ATP5PO": [
        "ATP5PO_162K",
        "ATP5PO_54K",
        "ATP5PO_90K"
    ],
    "ATP6AP2": [
        "ATP6AP2_284K"
    ],
    "ATP6V1B2": [
        "ATP6V1B2_403K"
    ],
    "ATP6V1H": [
        "ATP6V1H_371K"
    ],
    "ATPAF1": [
        "ATPAF1_125K"
    ],
    "ATXN10": [
        "ATXN10_384K"
    ],
    "BAD": [
        "BAD_36K"
    ],
    "BAG3": [
        "BAG3_418K"
    ],
    "BAIAP2": [
        "BAIAP2_206K",
        "BAIAP2_350K"
    ],
    "BANP": [
        "BANP_275K"
    ],
    "BARGIN": [
        "BARGIN_148K"
    ],
    "BAZ1A": [
        "BAZ1A_1383K"
    ],
    "BAZ1B": [
        "BAZ1B_1291K",
        "BAZ1B_396K",
        "BAZ1B_501K"
    ],
    "BAZ2A": [
        "BAZ2A_660K",
        "BAZ2A_662K",
        "BAZ2A_687K",
        "BAZ2A_799K"
    ],
    "BCAP31": [
        "BCAP31_158K"
    ],
    "BCAS1": [
        "BCAS1_325K"
    ],
    "BCAS2": [
        "BCAS2_158K"
    ],
    "BCAT1": [
        "BCAT1_215K"
    ],
    "BCKDK": [
        "BCKDK_192K"
    ],
    "BCL9L": [
        "BCL9L_108K",
        "BCL9L_110K",
        "BCL9L_36K",
        "BCL9L_43K",
        "BCL9L_49K",
        "BCL9L_83K"
    ],
    "BCLAF1": [
        "BCLAF1_332K",
        "BCLAF1_421K",
        "BCLAF1_741K"
    ],
    "BIN1": [
        "BIN1_7K"
    ],
    "BMS1": [
        "BMS1_728K",
        "BMS1_795K"
    ],
    "BOLA2": [
        "BOLA2_47K"
    ],
    "BPHL": [
        "BPHL_217K"
    ],
    "BPNT1": [
        "BPNT1_189K",
        "BPNT1_277K",
        "BPNT1_49K"
    ],
    "BPTF": [
        "BPTF_1077K"
    ],
    "BRD1": [
        "BRD1_23K",
        "BRD1_981K"
    ],
    "BRD3": [
        "BRD3_304K"
    ],
    "BRD4": [
        "BRD4_1135K",
        "BRD4_1197K",
        "BRD4_317K",
        "BRD4_594K"
    ],
    "BRIP1": [
        "BRIP1_954K"
    ],
    "BROX": [
        "BROX_317K"
    ],
    "BRPF1": [
        "BRPF1_1027K",
        "BRPF1_147K"
    ],
    "BRPF3": [
        "BRPF3_105K",
        "BRPF3_671K",
        "BRPF3_89K"
    ],
    "BTF3": [
        "BTF3_67K"
    ],
    "BUD13": [
        "BUD13_47K"
    ],
    "BUD31": [
        "BUD31_125K"
    ],
    "BYSL": [
        "BYSL_242K",
        "BYSL_390K"
    ],
    "BZW1": [
        "BZW1_191K",
        "BZW1_390K"
    ],
    "BZW2": [
        "BZW2_391K"
    ],
    "C4orf47": [
        "C4orf47_280K"
    ],
    "CAB39": [
        "CAB39_7K"
    ],
    "CACNA1S": [
        "CACNA1S_1245K"
    ],
    "CACYBP": [
        "CACYBP_146K",
        "CACYBP_212K"
    ],
    "CAD": [
        "CAD_1325K",
        "CAD_1411K",
        "CAD_2036K",
        "CAD_754K"
    ],
    "CAGE1": [
        "CAGE1_656K"
    ],
    "CALD1": [
        "CALD1_640K",
        "CALD1_655K",
        "CALD1_713K"
    ],
    "CALM3": [
        "CALM3_22K"
    ],
    "CALR": [
        "CALR_143K",
        "CALR_153K",
        "CALR_159K",
        "CALR_64K"
    ],
    "CAMK2D": [
        "CAMK2D_268K",
        "CAMK2D_445K",
        "CAMK2D_69K"
    ],
    "CAMK2G": [
        "CAMK2G_268K",
        "CAMK2G_318K"
    ],
    "CAND1": [
        "CAND1_574K",
        "CAND1_620K",
        "CAND1_971K"
    ],
    "CANX": [
        "CANX_103K",
        "CANX_118K",
        "CANX_127K",
        "CANX_210K",
        "CANX_217K",
        "CANX_227K"
    ],
    "CAP1": [
        "CAP1_209K",
        "CAP1_404K",
        "CAP1_412K",
        "CAP1_422K",
        "CAP1_71K"
    ],
    "CAP2": [
        "CAP2_175K",
        "CAP2_320K"
    ],
    "CAPN1": [
        "CAPN1_270K",
        "CAPN1_583K",
        "CAPN1_79K"
    ],
    "CAPN7": [
        "CAPN7_74K"
    ],
    "CAPNS1": [
        "CAPNS1_135K"
    ],
    "CAPZA1": [
        "CAPZA1_118K"
    ],
    "CAPZA2": [
        "CAPZA2_268K",
        "CAPZA2_91K"
    ],
    "CAPZB": [
        "CAPZB_235K",
        "CAPZB_57K"
    ],
    "CARHSP1": [
        "CARHSP1_117K"
    ],
    "CARS1": [
        "CARS1_280K",
        "CARS1_503K"
    ],
    "CASD1": [
        "CASD1_117K"
    ],
    "CASK": [
        "CASK_756K"
    ],
    "CASP7": [
        "CASP7_80K"
    ],
    "CAT": [
        "CAT_243K"
    ],
    "CAV1": [
        "CAV1_57K"
    ],
    "CAVIN1": [
        "CAVIN1_122K"
    ],
    "CBFB": [
        "CBFB_177K"
    ],
    "CBR1": [
        "CBR1_148K"
    ],
    "CBX1": [
        "CBX1_139K"
    ],
    "CBX3": [
        "CBX3_44K",
        "CBX3_5K"
    ],
    "CBX5": [
        "CBX5_102K"
    ],
    "CBY2": [
        "CBY2_180K"
    ],
    "CCAR1": [
        "CCAR1_659K",
        "CCAR1_788K",
        "CCAR1_967K"
    ],
    "CCDC124": [
        "CCDC124_11K",
        "CCDC124_121K"
    ],
    "CCDC6": [
        "CCDC6_266K"
    ],
    "CCNT1": [
        "CCNT1_492K"
    ],
    "CCS": [
        "CCS_262K"
    ],
    "CCT2": [
        "CCT2_191K",
        "CCT2_203K",
        "CCT2_284K"
    ],
    "CCT3": [
        "CCT3_222K",
        "CCT3_370K",
        "CCT3_427K",
        "CCT3_44K",
        "CCT3_78K"
    ],
    "CCT4": [
        "CCT4_126K",
        "CCT4_375K",
        "CCT4_489K",
        "CCT4_531K"
    ],
    "CCT5": [
        "CCT5_170K",
        "CCT5_176K",
        "CCT5_232K"
    ],
    "CCT6A": [
        "CCT6A_199K",
        "CCT6A_251K",
        "CCT6A_381K",
        "CCT6A_5K"
    ],
    "CCT7": [
        "CCT7_366K",
        "CCT7_368K",
        "CCT7_77K"
    ],
    "CCT8": [
        "CCT8_152K",
        "CCT8_20K",
        "CCT8_326K",
        "CCT8_466K"
    ],
    "CD2BP2": [
        "CD2BP2_44K"
    ],
    "CD59": [
        "CD59_90K"
    ],
    "CD9": [
        "CD9_179K"
    ],
    "CDC27": [
        "CDC27_701K"
    ],
    "CDC34": [
        "CDC34_193K"
    ],
    "CDC37": [
        "CDC37_126K",
        "CDC37_78K"
    ],
    "CDC42": [
        "CDC42_163K"
    ],
    "CDK1": [
        "CDK1_24K",
        "CDK1_33K",
        "CDK1_6K"
    ],
    "CDK11B": [
        "CDK11B_120K"
    ],
    "CDK12": [
        "CDK12_489K"
    ],
    "CDK9": [
        "CDK9_178K"
    ],
    "CDV3": [
        "CDV3_203K"
    ],
    "CEBPZ": [
        "CEBPZ_206K"
    ],
    "CENPB": [
        "CENPB_246K"
    ],
    "CENPV": [
        "CENPV_52K"
    ],
    "CEP170": [
        "CEP170_111K",
        "CEP170_195K"
    ],
    "CEP170B": [
        "CEP170B_1538K"
    ],
    "CEP43": [
        "CEP43_214K"
    ],
    "CERS6": [
        "CERS6_92K"
    ],
    "CETN1": [
        "CETN1_124K"
    ],
    "CFL1": [
        "CFL1_132K",
        "CFL1_144K",
        "CFL1_19K",
        "CFL1_44K",
        "CFL1_92K"
    ],
    "CGGBP1": [
        "CGGBP1_16K"
    ],
    "CGN": [
        "CGN_447K"
    ],
    "CHAF1A": [
        "CHAF1A_459K"
    ],
    "CHAMP1": [
        "CHAMP1_617K"
    ],
    "CHD1": [
        "CHD1_620K"
    ],
    "CHD1L": [
        "CHD1L_879K"
    ],
    "CHD4": [
        "CHD4_1206K",
        "CHD4_1778K",
        "CHD4_964K"
    ],
    "CHD7": [
        "CHD7_2230K"
    ],
    "CHERP": [
        "CHERP_879K"
    ],
    "CHMP1A": [
        "CHMP1A_40K"
    ],
    "CHMP1B": [
        "CHMP1B_59K",
        "CHMP1B_6K"
    ],
    "CHMP2B": [
        "CHMP2B_107K",
        "CHMP2B_81K"
    ],
    "CHMP3": [
        "CHMP3_6K"
    ],
    "CHTOP": [
        "CHTOP_28K",
        "CHTOP_81K"
    ],
    "CHUK": [
        "CHUK_466K"
    ],
    "CIAPIN1": [
        "CIAPIN1_247K"
    ],
    "CIP2A": [
        "CIP2A_21K"
    ],
    "CIR1": [
        "CIR1_3K"
    ],
    "CISD2": [
        "CISD2_105K"
    ],
    "CKAP5": [
        "CKAP5_1799K"
    ],
    "CKMT1A": [
        "CKMT1A_416K",
        "CKMT1A_58K"
    ],
    "CKS1B": [
        "CKS1B_34K"
    ],
    "CLASP1": [
        "CLASP1_1035K"
    ],
    "CLIC1": [
        "CLIC1_49K"
    ],
    "CLIC4": [
        "CLIC4_110K"
    ],
    "CLIP1": [
        "CLIP1_1039K",
        "CLIP1_14K"
    ],
    "CLP1": [
        "CLP1_127K"
    ],
    "CLPB": [
        "CLPB_623K"
    ],
    "CLPP": [
        "CLPP_211K"
    ],
    "CLPTM1": [
        "CLPTM1_460K",
        "CLPTM1_534K"
    ],
    "CLPTM1L": [
        "CLPTM1L_459K"
    ],
    "CLPX": [
        "CLPX_449K"
    ],
    "CLSPN": [
        "CLSPN_925K"
    ],
    "CLTA": [
        "CLTA_223K"
    ],
    "CLTB": [
        "CLTB_204K"
    ],
    "CLTC": [
        "CLTC_1347K",
        "CLTC_1441K",
        "CLTC_1501K",
        "CLTC_1516K",
        "CLTC_487K",
        "CLTC_737K"
    ],
    "CMC2": [
        "CMC2_49K"
    ],
    "CNBP": [
        "CNBP_103K"
    ],
    "CNN2": [
        "CNN2_19K",
        "CNN2_234K"
    ],
    "CNN3": [
        "CNN3_17K",
        "CNN3_256K"
    ],
    "CNOT1": [
        "CNOT1_372K"
    ],
    "CNP": [
        "CNP_164K"
    ],
    "COBLL1": [
        "COBLL1_886K"
    ],
    "COIL": [
        "COIL_167K"
    ],
    "COPA": [
        "COPA_1119K",
        "COPA_13K",
        "COPA_438K",
        "COPA_441K",
        "COPA_750K",
        "COPA_76K",
        "COPA_993K"
    ],
    "COPB1": [
        "COPB1_75K"
    ],
    "COPG1": [
        "COPG1_465K"
    ],
    "COPS2": [
        "COPS2_331K"
    ],
    "COPS3": [
        "COPS3_281K"
    ],
    "COPZ1": [
        "COPZ1_46K"
    ],
    "CORO1A": [
        "CORO1A_132K"
    ],
    "CORO1B": [
        "CORO1B_21K"
    ],
    "CORO1C": [
        "CORO1C_19K"
    ],
    "CORO7": [
        "CORO7_787K"
    ],
    "COX17": [
        "COX17_30K"
    ],
    "COX4I1": [
        "COX4I1_53K",
        "COX4I1_67K"
    ],
    "COX6B1": [
        "COX6B1_13K"
    ],
    "CPNE1": [
        "CPNE1_182K"
    ],
    "CPNE3": [
        "CPNE3_184K",
        "CPNE3_253K",
        "CPNE3_262K",
        "CPNE3_52K"
    ],
    "CPSF4": [
        "CPSF4_133K",
        "CPSF4_51K"
    ],
    "CPT1A": [
        "CPT1A_148K"
    ],
    "CPT1C": [
        "CPT1C_636K"
    ],
    "CRABP2": [
        "CRABP2_107K"
    ],
    "CRCP": [
        "CRCP_34K"
    ],
    "CREBBP": [
        "CREBBP_1014K",
        "CREBBP_1216K",
        "CREBBP_1583K",
        "CREBBP_1586K",
        "CREBBP_1587K",
        "CREBBP_1588K",
        "CREBBP_1591K",
        "CREBBP_1592K",
        "CREBBP_1595K",
        "CREBBP_1597K",
        "CREBBP_389K",
        "CREBBP_434K"
    ],
    "CRIP2": [
        "CRIP2_10K",
        "CRIP2_144K",
        "CRIP2_23K"
    ],
    "CRTC1": [
        "CRTC1_123K"
    ],
    "CS": [
        "CS_215K",
        "CS_366K",
        "CS_450K"
    ],
    "CSDE1": [
        "CSDE1_166K",
        "CSDE1_277K",
        "CSDE1_307K",
        "CSDE1_442K",
        "CSDE1_758K"
    ],
    "CSE1L": [
        "CSE1L_158K",
        "CSE1L_165K",
        "CSE1L_425K",
        "CSE1L_67K"
    ],
    "CSNK1A1": [
        "CSNK1A1_62K",
        "CSNK1A1_8K"
    ],
    "CSNK1D": [
        "CSNK1D_45K"
    ],
    "CSNK2B": [
        "CSNK2B_147K"
    ],
    "CSRP1": [
        "CSRP1_137K",
        "CSRP1_141K",
        "CSRP1_161K",
        "CSRP1_173K",
        "CSRP1_69K",
        "CSRP1_91K"
    ],
    "CSTB": [
        "CSTB_91K"
    ],
    "CTBP1": [
        "CTBP1_348K"
    ],
    "CTBP2": [
        "CTBP2_6K"
    ],
    "CTNNA1": [
        "CTNNA1_120K",
        "CTNNA1_737K",
        "CTNNA1_889K"
    ],
    "CTNND1": [
        "CTNND1_448K",
        "CTNND1_749K"
    ],
    "CTSD": [
        "CTSD_127K",
        "CTSD_357K"
    ],
    "CTSO": [
        "CTSO_117K"
    ],
    "CTTN": [
        "CTTN_107K",
        "CTTN_110K",
        "CTTN_144K",
        "CTTN_171K",
        "CTTN_181K",
        "CTTN_184K",
        "CTTN_208K",
        "CTTN_266K",
        "CTTN_295K",
        "CTTN_346K",
        "CTTN_79K",
        "CTTN_97K"
    ],
    "CUL1": [
        "CUL1_596K"
    ],
    "CUL3": [
        "CUL3_254K",
        "CUL3_271K",
        "CUL3_459K",
        "CUL3_542K"
    ],
    "CUL4A": [
        "CUL4A_561K"
    ],
    "CUL4B": [
        "CUL4B_619K",
        "CUL4B_634K",
        "CUL4B_715K",
        "CUL4B_815K",
        "CUL4B_822K"
    ],
    "CWC27": [
        "CWC27_126K",
        "CWC27_230K"
    ],
    "CYB5A": [
        "CYB5A_19K"
    ],
    "CYB5R1": [
        "CYB5R1_54K"
    ],
    "CYB5R3": [
        "CYB5R3_154K"
    ],
    "CYC1": [
        "CYC1_310K"
    ],
    "CYFIP1": [
        "CYFIP1_1188K",
        "CYFIP1_182K",
        "CYFIP1_320K",
        "CYFIP1_540K"
    ],
    "CYRIB": [
        "CYRIB_308K"
    ],
    "D2HGDH": [
        "D2HGDH_101K"
    ],
    "DAG1": [
        "DAG1_881K"
    ],
    "DAP": [
        "DAP_12K",
        "DAP_29K"
    ],
    "DARS1": [
        "DARS1_74K"
    ],
    "DARS2": [
        "DARS2_144K",
        "DARS2_606K"
    ],
    "DBI": [
        "DBI_55K",
        "DBI_77K"
    ],
    "DCAF4": [
        "DCAF4_360K"
    ],
    "DCPS": [
        "DCPS_10K",
        "DCPS_128K",
        "DCPS_138K"
    ],
    "DCTN1": [
        "DCTN1_262K",
        "DCTN1_38K"
    ],
    "DCTN2": [
        "DCTN2_289K",
        "DCTN2_65K"
    ],
    "DCXR": [
        "DCXR_17K",
        "DCXR_198K"
    ],
    "DDA1": [
        "DDA1_13K"
    ],
    "DDB1": [
        "DDB1_1067K",
        "DDB1_191K"
    ],
    "DDB2": [
        "DDB2_278K"
    ],
    "DDIAS": [
        "DDIAS_828K"
    ],
    "DDX1": [
        "DDX1_117K",
        "DDX1_132K",
        "DDX1_234K",
        "DDX1_451K",
        "DDX1_461K",
        "DDX1_636K",
        "DDX1_82K"
    ],
    "DDX17": [
        "DDX17_132K"
    ],
    "DDX18": [
        "DDX18_135K",
        "DDX18_584K"
    ],
    "DDX21": [
        "DDX21_116K",
        "DDX21_91K"
    ],
    "DDX23": [
        "DDX23_596K",
        "DDX23_682K",
        "DDX23_760K"
    ],
    "DDX24": [
        "DDX24_178K"
    ],
    "DDX39A": [
        "DDX39A_187K",
        "DDX39A_190K"
    ],
    "DDX39B": [
        "DDX39B_183K",
        "DDX39B_188K",
        "DDX39B_191K",
        "DDX39B_36K"
    ],
    "DDX3X": [
        "DDX3X_208K",
        "DDX3X_55K",
        "DDX3X_66K",
        "DDX3X_81K"
    ],
    "DDX42": [
        "DDX42_708K"
    ],
    "DDX46": [
        "DDX46_263K",
        "DDX46_372K",
        "DDX46_470K",
        "DDX46_776K"
    ],
    "DDX5": [
        "DDX5_197K",
        "DDX5_236K",
        "DDX5_388K",
        "DDX5_56K"
    ],
    "DDX56": [
        "DDX56_337K"
    ],
    "DDX58": [
        "DDX58_880K"
    ],
    "DDX6": [
        "DDX6_104K",
        "DDX6_86K"
    ],
    "DDX60L": [
        "DDX60L_915K"
    ],
    "DENND10": [
        "DENND10_115K"
    ],
    "DGKD": [
        "DGKD_1191K"
    ],
    "DHCR24": [
        "DHCR24_313K",
        "DHCR24_446K"
    ],
    "DHX15": [
        "DHX15_230K",
        "DHX15_491K"
    ],
    "DHX30": [
        "DHX30_313K"
    ],
    "DHX36": [
        "DHX36_862K",
        "DHX36_973K"
    ],
    "DHX38": [
        "DHX38_30K"
    ],
    "DHX9": [
        "DHX9_1024K",
        "DHX9_146K",
        "DHX9_467K"
    ],
    "DIABLO": [
        "DIABLO_146K"
    ],
    "DIP2B": [
        "DIP2B_113K"
    ],
    "DKC1": [
        "DKC1_443K"
    ],
    "DLAT": [
        "DLAT_473K"
    ],
    "DLD": [
        "DLD_127K",
        "DLD_143K",
        "DLD_159K",
        "DLD_166K",
        "DLD_277K",
        "DLD_430K",
        "DLD_445K",
        "DLD_66K"
    ],
    "DLST": [
        "DLST_217K",
        "DLST_267K",
        "DLST_67K"
    ],
    "DMAC1": [
        "DMAC1_45K"
    ],
    "DNAJA1": [
        "DNAJA1_130K",
        "DNAJA1_296K"
    ],
    "DNAJA2": [
        "DNAJA2_139K",
        "DNAJA2_152K"
    ],
    "DNAJB1": [
        "DNAJB1_181K",
        "DNAJB1_195K"
    ],
    "DNAJB11": [
        "DNAJB11_247K"
    ],
    "DNAJB2": [
        "DNAJB2_59K"
    ],
    "DNAJC10": [
        "DNAJC10_392K"
    ],
    "DNAJC13": [
        "DNAJC13_8K"
    ],
    "DNAJC2": [
        "DNAJC2_117K"
    ],
    "DNAJC7": [
        "DNAJC7_368K",
        "DNAJC7_60K"
    ],
    "DNAJC8": [
        "DNAJC8_40K"
    ],
    "DNM1L": [
        "DNM1L_597K"
    ],
    "DNM2": [
        "DNM2_393K"
    ],
    "DNMT1": [
        "DNMT1_83K"
    ],
    "DOCK6": [
        "DOCK6_1871K"
    ],
    "DOCK7": [
        "DOCK7_1962K",
        "DOCK7_2080K",
        "DOCK7_381K"
    ],
    "DPAGT1": [
        "DPAGT1_48K"
    ],
    "DPP3": [
        "DPP3_235K",
        "DPP3_629K"
    ],
    "DPY19L2P1": [
        "DPY19L2P1_42K"
    ],
    "DPYSL3": [
        "DPYSL3_258K"
    ],
    "DRAP1": [
        "DRAP1_63K"
    ],
    "DSP": [
        "DSP_140K",
        "DSP_1413K",
        "DSP_1802K",
        "DSP_2778K",
        "DSP_478K"
    ],
    "DST": [
        "DST_54K"
    ],
    "DSTN": [
        "DSTN_132K",
        "DSTN_19K",
        "DSTN_30K"
    ],
    "DTD1": [
        "DTD1_61K"
    ],
    "DTX3L": [
        "DTX3L_408K"
    ],
    "DYNC1H1": [
        "DYNC1H1_1115K",
        "DYNC1H1_1992K",
        "DYNC1H1_3232K",
        "DYNC1H1_576K",
        "DYNC1H1_624K",
        "DYNC1H1_956K"
    ],
    "DYNC1LI1": [
        "DYNC1LI1_68K"
    ],
    "DYNLRB1": [
        "DYNLRB1_9K"
    ],
    "EAF1": [
        "EAF1_150K"
    ],
    "ECD": [
        "ECD_250K"
    ],
    "ECH1": [
        "ECH1_65K",
        "ECH1_83K",
        "ECH1_95K"
    ],
    "ECHDC1": [
        "ECHDC1_108K"
    ],
    "ECHS1": [
        "ECHS1_118K",
        "ECHS1_43K"
    ],
    "ECI2": [
        "ECI2_92K"
    ],
    "ECPAS": [
        "ECPAS_1475K"
    ],
    "EDC3": [
        "EDC3_329K",
        "EDC3_346K"
    ],
    "EDF1": [
        "EDF1_25K"
    ],
    "EEA1": [
        "EEA1_1312K",
        "EEA1_324K"
    ],
    "EEF1A1P5": [
        "EEF1A1P5_165K",
        "EEF1A1P5_395K",
        "EEF1A1P5_450K",
        "EEF1A1P5_453K",
        "EEF1A1P5_457K"
    ],
    "EEF1A2": [
        "EEF1A2_392K",
        "EEF1A2_395K",
        "EEF1A2_439K",
        "EEF1A2_453K"
    ],
    "EEF1B2": [
        "EEF1B2_60K"
    ],
    "EEF1D": [
        "EEF1D_117K"
    ],
    "EEF1E1": [
        "EEF1E1_88K"
    ],
    "EEF1G": [
        "EEF1G_277K",
        "EEF1G_434K"
    ],
    "EEF2": [
        "EEF2_152K",
        "EEF2_239K",
        "EEF2_275K",
        "EEF2_308K",
        "EEF2_32K",
        "EEF2_426K",
        "EEF2_439K",
        "EEF2_571K",
        "EEF2_598K"
    ],
    "EFTUD2": [
        "EFTUD2_244K"
    ],
    "EHD1": [
        "EHD1_208K",
        "EHD1_220K"
    ],
    "EHD2": [
        "EHD2_220K"
    ],
    "EHD4": [
        "EHD4_223K"
    ],
    "EHMT1": [
        "EHMT1_153K",
        "EHMT1_161K"
    ],
    "EIF1": [
        "EIF1_56K"
    ],
    "EIF1AX": [
        "EIF1AX_56K",
        "EIF1AX_88K"
    ],
    "EIF2A": [
        "EIF2A_121K",
        "EIF2A_192K",
        "EIF2A_223K"
    ],
    "EIF2B3": [
        "EIF2B3_189K"
    ],
    "EIF2S2": [
        "EIF2S2_79K"
    ],
    "EIF2S3": [
        "EIF2S3_183K",
        "EIF2S3_421K",
        "EIF2S3_54K",
        "EIF2S3_70K"
    ],
    "EIF3A": [
        "EIF3A_1369K",
        "EIF3A_409K",
        "EIF3A_632K"
    ],
    "EIF3B": [
        "EIF3B_204K",
        "EIF3B_729K"
    ],
    "EIF3C": [
        "EIF3C_513K"
    ],
    "EIF3D": [
        "EIF3D_41K",
        "EIF3D_426K"
    ],
    "EIF3E": [
        "EIF3E_409K"
    ],
    "EIF3G": [
        "EIF3G_71K"
    ],
    "EIF3H": [
        "EIF3H_227K"
    ],
    "EIF3I": [
        "EIF3I_282K",
        "EIF3I_91K"
    ],
    "EIF3L": [
        "EIF3L_143K",
        "EIF3L_347K"
    ],
    "EIF3M": [
        "EIF3M_324K",
        "EIF3M_365K"
    ],
    "EIF4A1": [
        "EIF4A1_174K"
    ],
    "EIF4B": [
        "EIF4B_177K",
        "EIF4B_194K",
        "EIF4B_529K"
    ],
    "EIF4E": [
        "EIF4E_206K",
        "EIF4E_36K"
    ],
    "EIF4G1": [
        "EIF4G1_1000K",
        "EIF4G1_1095K",
        "EIF4G1_925K"
    ],
    "EIF4G2": [
        "EIF4G2_233K",
        "EIF4G2_271K",
        "EIF4G2_31K",
        "EIF4G2_484K",
        "EIF4G2_575K"
    ],
    "EIF5A2": [
        "EIF5A2_47K",
        "EIF5A2_50K",
        "EIF5A2_85K"
    ],
    "EIF5B": [
        "EIF5B_284K",
        "EIF5B_410K"
    ],
    "ELAPOR1": [
        "ELAPOR1_376K"
    ],
    "ELAVL1": [
        "ELAVL1_320K"
    ],
    "ELMO2": [
        "ELMO2_401K"
    ],
    "ELMO3": [
        "ELMO3_395K"
    ],
    "ELOB": [
        "ELOB_11K"
    ],
    "ELOC": [
        "ELOC_32K"
    ],
    "EMG1": [
        "EMG1_59K",
        "EMG1_68K"
    ],
    "EML2": [
        "EML2_8K"
    ],
    "ENO1": [
        "ENO1_193K",
        "ENO1_228K",
        "ENO1_233K",
        "ENO1_335K",
        "ENO1_406K",
        "ENO1_5K",
        "ENO1_64K",
        "ENO1_71K"
    ],
    "EP300": [
        "EP300_1180K",
        "EP300_1542K",
        "EP300_1546K",
        "EP300_1549K",
        "EP300_1550K",
        "EP300_1551K",
        "EP300_1554K",
        "EP300_1555K",
        "EP300_1558K",
        "EP300_1560K",
        "EP300_1590K",
        "EP300_1637K",
        "EP300_1674K",
        "EP300_1769K",
        "EP300_1772K",
        "EP300_1794K",
        "EP300_373K"
    ],
    "EPB41L5": [
        "EPB41L5_350K"
    ],
    "EPC2": [
        "EPC2_23K"
    ],
    "EPHX1": [
        "EPHX1_386K"
    ],
    "EPPK1": [
        "EPPK1_2525K",
        "EPPK1_2707K",
        "EPPK1_2753K"
    ],
    "EPRS1": [
        "EPRS1_1109K",
        "EPRS1_1375K",
        "EPRS1_599K",
        "EPRS1_650K",
        "EPRS1_725K",
        "EPRS1_907K"
    ],
    "EPS8": [
        "EPS8_336K"
    ],
    "ERCC3": [
        "ERCC3_771K"
    ],
    "ERH": [
        "ERH_41K",
        "ERH_84K"
    ],
    "ERO1B": [
        "ERO1B_401K"
    ],
    "ERVK-5": [
        "ERVK-5_316K"
    ],
    "ESYT1": [
        "ESYT1_235K",
        "ESYT1_817K"
    ],
    "ETF1": [
        "ETF1_354K"
    ],
    "ETFA": [
        "ETFA_164K",
        "ETFA_206K",
        "ETFA_226K",
        "ETFA_62K"
    ],
    "EWSR1": [
        "EWSR1_439K"
    ],
    "EXOC1": [
        "EXOC1_5K"
    ],
    "EXOC3": [
        "EXOC3_28K"
    ],
    "EXOSC10": [
        "EXOSC10_865K"
    ],
    "EXOSC7": [
        "EXOSC7_116K"
    ],
    "EZR": [
        "EZR_143K",
        "EZR_3K"
    ],
    "FABP5": [
        "FABP5_55K",
        "FABP5_61K"
    ],
    "FADD": [
        "FADD_125K"
    ],
    "FAF1": [
        "FAF1_146K"
    ],
    "FAH": [
        "FAH_316K"
    ],
    "FAHD2A": [
        "FAHD2A_234K"
    ],
    "FAM120A": [
        "FAM120A_932K"
    ],
    "FAM136A": [
        "FAM136A_99K"
    ],
    "FAM13B": [
        "FAM13B_618K",
        "FAM13B_624K"
    ],
    "FAM3C": [
        "FAM3C_67K"
    ],
    "FAM50B": [
        "FAM50B_302K"
    ],
    "FAM76A": [
        "FAM76A_50K"
    ],
    "FAM76B": [
        "FAM76B_52K"
    ],
    "FAM83H": [
        "FAM83H_1053K"
    ],
    "FAM98B": [
        "FAM98B_136K",
        "FAM98B_245K",
        "FAM98B_299K"
    ],
    "FANCD2": [
        "FANCD2_878K"
    ],
    "FAR1": [
        "FAR1_161K"
    ],
    "FARP1": [
        "FARP1_772K"
    ],
    "FARSB": [
        "FARSB_443K"
    ],
    "FASN": [
        "FASN_1072K",
        "FASN_1704K",
        "FASN_1847K",
        "FASN_1871K",
        "FASN_1878K",
        "FASN_1995K",
        "FASN_2193K",
        "FASN_41K",
        "FASN_776K",
        "FASN_786K"
    ],
    "FAU": [
        "FAU_51K"
    ],
    "FBL": [
        "FBL_102K",
        "FBL_109K",
        "FBL_84K"
    ],
    "FBP1": [
        "FBP1_334K"
    ],
    "FBXO11": [
        "FBXO11_142K"
    ],
    "FBXO22": [
        "FBXO22_197K"
    ],
    "FCF1": [
        "FCF1_137K"
    ],
    "FDPS": [
        "FDPS_123K"
    ],
    "FEN1": [
        "FEN1_252K"
    ],
    "FHL2": [
        "FHL2_139K"
    ],
    "FIP1L1": [
        "FIP1L1_135K"
    ],
    "FKBP1A": [
        "FKBP1A_53K"
    ],
    "FKBP3": [
        "FKBP3_121K",
        "FKBP3_170K",
        "FKBP3_200K",
        "FKBP3_48K",
        "FKBP3_80K",
        "FKBP3_99K"
    ],
    "FKBP4": [
        "FKBP4_250K",
        "FKBP4_287K",
        "FKBP4_354K",
        "FKBP4_390K"
    ],
    "FKBP8": [
        "FKBP8_340K"
    ],
    "FKBP9": [
        "FKBP9_566K"
    ],
    "FLNA": [
        "FLNA_1007K",
        "FLNA_1071K",
        "FLNA_1162K",
        "FLNA_1294K",
        "FLNA_1450K",
        "FLNA_1824K",
        "FLNA_2569K",
        "FLNA_2575K",
        "FLNA_2607K",
        "FLNA_2623K",
        "FLNA_270K",
        "FLNA_299K",
        "FLNA_508K",
        "FLNA_569K",
        "FLNA_626K",
        "FLNA_700K",
        "FLNA_771K",
        "FLNA_773K",
        "FLNA_781K",
        "FLNA_987K",
        "FLNA_994K"
    ],
    "FLNB": [
        "FLNB_1510K",
        "FLNB_1780K",
        "FLNB_1897K",
        "FLNB_2150K",
        "FLNB_2530K",
        "FLNB_313K",
        "FLNB_697K"
    ],
    "FLNC": [
        "FLNC_1367K",
        "FLNC_1831K",
        "FLNC_1935K",
        "FLNC_1994K",
        "FLNC_2022K",
        "FLNC_2117K",
        "FLNC_2463K",
        "FLNC_2685K"
    ],
    "FNDC3A": [
        "FNDC3A_384K"
    ],
    "FOSL2": [
        "FOSL2_104K"
    ],
    "FOXA1": [
        "FOXA1_316K"
    ],
    "FOXO3": [
        "FOXO3_242K"
    ],
    "FSCN1": [
        "FSCN1_220K",
        "FSCN1_74K"
    ],
    "FTSJ3": [
        "FTSJ3_233K"
    ],
    "FUBP1": [
        "FUBP1_243K",
        "FUBP1_312K"
    ],
    "FUBP3": [
        "FUBP3_220K",
        "FUBP3_290K"
    ],
    "FUNDC2": [
        "FUNDC2_161K"
    ],
    "FUT8": [
        "FUT8_138K"
    ],
    "FXR1": [
        "FXR1_207K"
    ],
    "FXR2": [
        "FXR2_217K"
    ],
    "G3BP1": [
        "G3BP1_76K"
    ],
    "G6PD": [
        "G6PD_497K"
    ],
    "GALK2": [
        "GALK2_177K",
        "GALK2_333K"
    ],
    "GANAB": [
        "GANAB_39K",
        "GANAB_491K",
        "GANAB_908K"
    ],
    "GAPDH": [
        "GAPDH_194K",
        "GAPDH_254K",
        "GAPDH_334K"
    ],
    "GAPVD1": [
        "GAPVD1_1393K"
    ],
    "GARS1": [
        "GARS1_207K",
        "GARS1_477K",
        "GARS1_646K"
    ],
    "GART": [
        "GART_501K"
    ],
    "GATAD2B": [
        "GATAD2B_462K"
    ],
    "GCAT": [
        "GCAT_113K"
    ],
    "GCC2": [
        "GCC2_1274K"
    ],
    "GCLC": [
        "GCLC_182K"
    ],
    "GCLM": [
        "GCLM_255K",
        "GCLM_263K"
    ],
    "GCN1": [
        "GCN1_2183K",
        "GCN1_308K",
        "GCN1_436K",
        "GCN1_561K"
    ],
    "GDAP1": [
        "GDAP1_203K"
    ],
    "GDF15": [
        "GDF15_258K"
    ],
    "GDI1": [
        "GDI1_269K"
    ],
    "GDI2": [
        "GDI2_210K",
        "GDI2_269K",
        "GDI2_309K"
    ],
    "GEMIN5": [
        "GEMIN5_1363K",
        "GEMIN5_426K",
        "GEMIN5_428K"
    ],
    "GET3": [
        "GET3_50K"
    ],
    "GET4": [
        "GET4_209K",
        "GET4_58K"
    ],
    "GFM1": [
        "GFM1_302K"
    ],
    "GGA1": [
        "GGA1_165K"
    ],
    "GGA3": [
        "GGA3_650K"
    ],
    "GGCT": [
        "GGCT_118K",
        "GGCT_88K"
    ],
    "GHITM": [
        "GHITM_76K"
    ],
    "GLG1": [
        "GLG1_516K"
    ],
    "GLIPR2": [
        "GLIPR2_53K"
    ],
    "GLS": [
        "GLS_164K"
    ],
    "GLUD1": [
        "GLUD1_191K",
        "GLUD1_390K",
        "GLUD1_480K"
    ],
    "GMEB2": [
        "GMEB2_136K"
    ],
    "GMPPA": [
        "GMPPA_275K"
    ],
    "GNAI3": [
        "GNAI3_92K"
    ],
    "GNAS": [
        "GNAS_53K",
        "GNAS_8K",
        "GNAS_91K",
        "GNAS_96K"
    ],
    "GNB1": [
        "GNB1_15K"
    ],
    "GNL2": [
        "GNL2_705K"
    ],
    "GOLGB1": [
        "GOLGB1_1607K"
    ],
    "GOLT1B": [
        "GOLT1B_62K"
    ],
    "GOT2": [
        "GOT2_296K",
        "GOT2_363K",
        "GOT2_90K"
    ],
    "GPATCH8": [
        "GPATCH8_61K"
    ],
    "GPD2": [
        "GPD2_113K",
        "GPD2_409K"
    ],
    "GPHN": [
        "GPHN_138K",
        "GPHN_311K"
    ],
    "GPI": [
        "GPI_142K",
        "GPI_241K",
        "GPI_252K",
        "GPI_34K"
    ],
    "GPS1": [
        "GPS1_150K",
        "GPS1_467K"
    ],
    "GPT2": [
        "GPT2_204K",
        "GPT2_505K"
    ],
    "GRB2": [
        "GRB2_50K"
    ],
    "GRPEL1": [
        "GRPEL1_157K",
        "GRPEL1_196K"
    ],
    "GRSF1": [
        "GRSF1_242K"
    ],
    "GRWD1": [
        "GRWD1_341K"
    ],
    "GSDMC": [
        "GSDMC_328K"
    ],
    "GSN": [
        "GSN_360K"
    ],
    "GSPT1": [
        "GSPT1_138K",
        "GSPT1_152K",
        "GSPT1_208K"
    ],
    "GSR": [
        "GSR_456K"
    ],
    "GSTK1": [
        "GSTK1_54K"
    ],
    "GSTM3": [
        "GSTM3_128K",
        "GSTM3_73K",
        "GSTM3_87K"
    ],
    "GSTO1": [
        "GSTO1_152K"
    ],
    "GTF2F1": [
        "GTF2F1_435K"
    ],
    "GTF2F2": [
        "GTF2F2_33K"
    ],
    "GTF2H1": [
        "GTF2H1_240K"
    ],
    "GTF2I": [
        "GTF2I_130K",
        "GTF2I_435K",
        "GTF2I_561K"
    ],
    "GTPBP1": [
        "GTPBP1_330K"
    ],
    "GTPBP10": [
        "GTPBP10_222K"
    ],
    "GTPBP4": [
        "GTPBP4_352K"
    ],
    "GUK1": [
        "GUK1_17K"
    ],
    "GULP1": [
        "GULP1_11K"
    ],
    "H1-0": [
        "H1-0_59K"
    ],
    "H1-2": [
        "H1-2_75K",
        "H1-2_90K",
        "H1-2_97K"
    ],
    "H1-5": [
        "H1-5_78K"
    ],
    "H2AC6": [
        "H2AC6_10K",
        "H2AC6_6K"
    ],
    "H2AX": [
        "H2AX_128K",
        "H2AX_134K",
        "H2AX_6K"
    ],
    "H2AZ1": [
        "H2AZ1_116K",
        "H2AZ1_12K",
        "H2AZ1_14K",
        "H2AZ1_5K",
        "H2AZ1_8K"
    ],
    "H2AZ2": [
        "H2AZ2_12K",
        "H2AZ2_14K",
        "H2AZ2_5K",
        "H2AZ2_8K"
    ],
    "H2BC13": [
        "H2BC13_12K",
        "H2BC13_13K",
        "H2BC13_16K",
        "H2BC13_17K",
        "H2BC13_6K"
    ],
    "H2BC14": [
        "H2BC14_12K",
        "H2BC14_13K",
        "H2BC14_16K",
        "H2BC14_17K",
        "H2BC14_21K",
        "H2BC14_24K",
        "H2BC14_6K"
    ],
    "H2BC15": [
        "H2BC15_12K",
        "H2BC15_13K",
        "H2BC15_16K",
        "H2BC15_17K",
        "H2BC15_6K"
    ],
    "H2BC18": [
        "H2BC18_13K",
        "H2BC18_16K",
        "H2BC18_17K",
        "H2BC18_21K",
        "H2BC18_24K"
    ],
    "H2BC3": [
        "H2BC3_12K",
        "H2BC3_13K",
        "H2BC3_16K",
        "H2BC3_17K",
        "H2BC3_21K",
        "H2BC3_24K"
    ],
    "H2BC4": [
        "H2BC4_109K",
        "H2BC4_117K",
        "H2BC4_12K",
        "H2BC4_13K",
        "H2BC4_16K",
        "H2BC4_17K",
        "H2BC4_21K",
        "H2BC4_24K",
        "H2BC4_25K",
        "H2BC4_35K",
        "H2BC4_6K"
    ],
    "H2BC5": [
        "H2BC5_12K",
        "H2BC5_13K",
        "H2BC5_16K",
        "H2BC5_17K",
        "H2BC5_6K"
    ],
    "H2BC9": [
        "H2BC9_12K",
        "H2BC9_13K",
        "H2BC9_16K",
        "H2BC9_17K",
        "H2BC9_6K"
    ],
    "H3-2": [
        "H3-2_80K"
    ],
    "H3-3A": [
        "H3-3A_28K",
        "H3-3A_37K"
    ],
    "H3-4": [
        "H3-4_15K",
        "H3-4_19K",
        "H3-4_24K",
        "H3-4_28K",
        "H3-4_37K"
    ],
    "H3C1": [
        "H3C1_10K",
        "H3C1_15K",
        "H3C1_19K",
        "H3C1_24K",
        "H3C1_28K",
        "H3C1_37K",
        "H3C1_57K",
        "H3C1_80K"
    ],
    "H3Y1": [
        "H3Y1_24K"
    ],
    "H4C1": [
        "H4C1_13K",
        "H4C1_17K",
        "H4C1_32K",
        "H4C1_6K",
        "H4C1_78K",
        "H4C1_92K",
        "H4C1_9K"
    ],
    "H4C7": [
        "H4C7_13K",
        "H4C7_17K",
        "H4C7_6K",
        "H4C7_9K"
    ],
    "HADH": [
        "HADH_127K",
        "HADH_206K",
        "HADH_212K"
    ],
    "HADHA": [
        "HADHA_295K",
        "HADHA_350K",
        "HADHA_406K",
        "HADHA_60K",
        "HADHA_644K"
    ],
    "HARS1": [
        "HARS1_243K"
    ],
    "HARS2": [
        "HARS2_444K"
    ],
    "HAT1": [
        "HAT1_15K"
    ],
    "HBS1L": [
        "HBS1L_622K"
    ],
    "HDAC1": [
        "HDAC1_220K"
    ],
    "HDGF": [
        "HDGF_39K"
    ],
    "HDLBP": [
        "HDLBP_1062K",
        "HDLBP_179K",
        "HDLBP_453K",
        "HDLBP_599K",
        "HDLBP_991K"
    ],
    "HEATR6": [
        "HEATR6_1137K"
    ],
    "HECTD1": [
        "HECTD1_444K"
    ],
    "HGS": [
        "HGS_126K"
    ],
    "HIBCH": [
        "HIBCH_353K"
    ],
    "HINT1": [
        "HINT1_21K",
        "HINT1_92K"
    ],
    "HK1": [
        "HK1_418K"
    ],
    "HM13": [
        "HM13_61K"
    ],
    "HMBS": [
        "HMBS_132K",
        "HMBS_348K",
        "HMBS_70K",
        "HMBS_74K"
    ],
    "HMCES": [
        "HMCES_294K"
    ],
    "HMG20A": [
        "HMG20A_255K"
    ],
    "HMGA1": [
        "HMGA1_7K"
    ],
    "HMGA2": [
        "HMGA2_90K"
    ],
    "HMGB1": [
        "HMGB1_114K",
        "HMGB1_12K",
        "HMGB1_30K",
        "HMGB1_43K",
        "HMGB1_50K"
    ],
    "HMGB2": [
        "HMGB2_114K",
        "HMGB2_30K",
        "HMGB2_3K",
        "HMGB2_76K"
    ],
    "HMGB3": [
        "HMGB3_112K"
    ],
    "HMGCL": [
        "HMGCL_48K"
    ],
    "HMGCS1": [
        "HMGCS1_409K"
    ],
    "HNRNPA1": [
        "HNRNPA1_105K",
        "HNRNPA1_350K",
        "HNRNPA1_3K",
        "HNRNPA1_78K",
        "HNRNPA1_8K"
    ],
    "HNRNPA2B1": [
        "HNRNPA2B1_112K"
    ],
    "HNRNPA3": [
        "HNRNPA3_126K",
        "HNRNPA3_29K"
    ],
    "HNRNPAB": [
        "HNRNPAB_227K"
    ],
    "HNRNPC": [
        "HNRNPC_170K",
        "HNRNPC_176K",
        "HNRNPC_189K",
        "HNRNPC_197K",
        "HNRNPC_39K",
        "HNRNPC_42K",
        "HNRNPC_8K"
    ],
    "HNRNPD": [
        "HNRNPD_243K"
    ],
    "HNRNPH3": [
        "HNRNPH3_76K"
    ],
    "HNRNPK": [
        "HNRNPK_198K",
        "HNRNPK_34K",
        "HNRNPK_405K",
        "HNRNPK_52K"
    ],
    "HNRNPL": [
        "HNRNPL_493K",
        "HNRNPL_62K"
    ],
    "HNRNPM": [
        "HNRNPM_134K",
        "HNRNPM_239K"
    ],
    "HNRNPR": [
        "HNRNPR_103K",
        "HNRNPR_255K",
        "HNRNPR_259K",
        "HNRNPR_94K"
    ],
    "HNRNPU": [
        "HNRNPU_186K",
        "HNRNPU_333K",
        "HNRNPU_352K",
        "HNRNPU_387K",
        "HNRNPU_516K",
        "HNRNPU_609K",
        "HNRNPU_626K",
        "HNRNPU_697K"
    ],
    "HNRNPUL1": [
        "HNRNPUL1_440K"
    ],
    "HNRNPUL2": [
        "HNRNPUL2_26K",
        "HNRNPUL2_297K",
        "HNRNPUL2_506K"
    ],
    "HOOK1": [
        "HOOK1_499K"
    ],
    "HOXC9": [
        "HOXC9_119K"
    ],
    "HP1BP3": [
        "HP1BP3_175K"
    ],
    "HPRT1": [
        "HPRT1_103K"
    ],
    "HSD17B12": [
        "HSD17B12_72K"
    ],
    "HSD17B4": [
        "HSD17B4_84K"
    ],
    "HSDL2": [
        "HSDL2_42K"
    ],
    "HSP90AA1": [
        "HSP90AA1_209K",
        "HSP90AA1_443K",
        "HSP90AA1_489K",
        "HSP90AA1_539K",
        "HSP90AA1_576K",
        "HSP90AA1_632K"
    ],
    "HSP90AB1": [
        "HSP90AB1_107K",
        "HSP90AB1_180K",
        "HSP90AB1_204K",
        "HSP90AB1_263K",
        "HSP90AB1_275K",
        "HSP90AB1_284K",
        "HSP90AB1_286K",
        "HSP90AB1_347K",
        "HSP90AB1_399K",
        "HSP90AB1_481K",
        "HSP90AB1_531K",
        "HSP90AB1_550K",
        "HSP90AB1_559K",
        "HSP90AB1_624K",
        "HSP90AB1_72K"
    ],
    "HSP90B1": [
        "HSP90B1_142K",
        "HSP90B1_161K",
        "HSP90B1_168K",
        "HSP90B1_356K",
        "HSP90B1_404K",
        "HSP90B1_95K",
        "HSP90B1_97K"
    ],
    "HSPA1B": [
        "HSPA1B_246K",
        "HSPA1B_328K",
        "HSPA1B_500K",
        "HSPA1B_507K",
        "HSPA1B_71K"
    ],
    "HSPA4": [
        "HSPA4_44K",
        "HSPA4_53K",
        "HSPA4_61K",
        "HSPA4_679K",
        "HSPA4_717K"
    ],
    "HSPA4L": [
        "HSPA4L_53K"
    ],
    "HSPA5": [
        "HSPA5_370K",
        "HSPA5_523K",
        "HSPA5_81K"
    ],
    "HSPA8": [
        "HSPA8_102K",
        "HSPA8_112K",
        "HSPA8_128K",
        "HSPA8_328K",
        "HSPA8_507K",
        "HSPA8_512K",
        "HSPA8_539K",
        "HSPA8_56K",
        "HSPA8_71K"
    ],
    "HSPA9": [
        "HSPA9_138K",
        "HSPA9_300K",
        "HSPA9_394K",
        "HSPA9_563K"
    ],
    "HSPB1": [
        "HSPB1_112K",
        "HSPB1_114K",
        "HSPB1_123K",
        "HSPB1_198K"
    ],
    "HSPD1": [
        "HSPD1_233K",
        "HSPD1_352K",
        "HSPD1_481K",
        "HSPD1_91K"
    ],
    "HSPE1": [
        "HSPE1_56K",
        "HSPE1_80K"
    ],
    "HSPH1": [
        "HSPH1_53K"
    ],
    "HTATIP2": [
        "HTATIP2_125K"
    ],
    "HTT": [
        "HTT_1512K"
    ],
    "HUWE1": [
        "HUWE1_2172K",
        "HUWE1_2267K",
        "HUWE1_4134K",
        "HUWE1_674K"
    ],
    "HYOU1": [
        "HYOU1_463K"
    ],
    "HYPK": [
        "HYPK_35K"
    ],
    "IARS1": [
        "IARS1_132K"
    ],
    "IARS2": [
        "IARS2_241K",
        "IARS2_325K",
        "IARS2_451K",
        "IARS2_540K"
    ],
    "ID1": [
        "ID1_23K"
    ],
    "IDE": [
        "IDE_192K",
        "IDE_353K",
        "IDE_483K"
    ],
    "IDH1": [
        "IDH1_115K",
        "IDH1_236K"
    ],
    "IDH2": [
        "IDH2_155K",
        "IDH2_180K",
        "IDH2_272K",
        "IDH2_275K",
        "IDH2_282K"
    ],
    "IDH3B": [
        "IDH3B_108K"
    ],
    "IGF2BP1": [
        "IGF2BP1_228K",
        "IGF2BP1_272K",
        "IGF2BP1_483K"
    ],
    "ILK": [
        "ILK_426K"
    ],
    "IMPDH1": [
        "IMPDH1_349K"
    ],
    "IMPDH2": [
        "IMPDH2_349K",
        "IMPDH2_422K",
        "IMPDH2_438K",
        "IMPDH2_511K"
    ],
    "INF2": [
        "INF2_682K"
    ],
    "ING3": [
        "ING3_167K",
        "ING3_400K"
    ],
    "ING4": [
        "ING4_114K",
        "ING4_127K",
        "ING4_129K",
        "ING4_130K",
        "ING4_146K",
        "ING4_148K",
        "ING4_156K",
        "ING4_236K"
    ],
    "INPP4B": [
        "INPP4B_891K"
    ],
    "INSRR": [
        "INSRR_1151K"
    ],
    "INTS13": [
        "INTS13_549K"
    ],
    "INTS3": [
        "INTS3_7K"
    ],
    "INTS4": [
        "INTS4_157K",
        "INTS4_35K"
    ],
    "IPO5": [
        "IPO5_806K"
    ],
    "IPO7": [
        "IPO7_1013K",
        "IPO7_489K"
    ],
    "IPO9": [
        "IPO9_277K",
        "IPO9_773K"
    ],
    "IQGAP1": [
        "IQGAP1_1027K",
        "IQGAP1_104K",
        "IQGAP1_1475K",
        "IQGAP1_1532K",
        "IQGAP1_997K"
    ],
    "IRF2BP1": [
        "IRF2BP1_73K"
    ],
    "ISOC1": [
        "ISOC1_279K"
    ],
    "ISYNA1": [
        "ISYNA1_305K"
    ],
    "ITPRID2": [
        "ITPRID2_1137K"
    ],
    "IVD": [
        "IVD_78K"
    ],
    "JADE1": [
        "JADE1_302K",
        "JADE1_331K"
    ],
    "JADE2": [
        "JADE2_298K",
        "JADE2_32K",
        "JADE2_38K",
        "JADE2_637K"
    ],
    "JADE3": [
        "JADE3_299K",
        "JADE3_30K",
        "JADE3_32K",
        "JADE3_38K",
        "JADE3_601K"
    ],
    "JPH1": [
        "JPH1_387K"
    ],
    "JPH2": [
        "JPH2_647K"
    ],
    "JPT1": [
        "JPT1_148K"
    ],
    "JPT2": [
        "JPT2_124K",
        "JPT2_184K",
        "JPT2_67K",
        "JPT2_90K"
    ],
    "JUN": [
        "JUN_56K"
    ],
    "KANSL1L": [
        "KANSL1L_859K"
    ],
    "KARS1": [
        "KARS1_363K"
    ],
    "KAT5": [
        "KAT5_104K"
    ],
    "KAT6A": [
        "KAT6A_1007K",
        "KAT6A_172K",
        "KAT6A_355K",
        "KAT6A_815K"
    ],
    "KAT6B": [
        "KAT6B_1038K",
        "KAT6B_1042K",
        "KAT6B_1044K",
        "KAT6B_379K",
        "KAT6B_393K"
    ],
    "KAT7": [
        "KAT7_199K"
    ],
    "KDELR2": [
        "KDELR2_83K"
    ],
    "KDM5B": [
        "KDM5B_832K"
    ],
    "KDM6A": [
        "KDM6A_799K"
    ],
    "KHDC4": [
        "KHDC4_91K"
    ],
    "KHDRBS1": [
        "KHDRBS1_200K"
    ],
    "KHSRP": [
        "KHSRP_359K"
    ],
    "KIF11": [
        "KIF11_357K"
    ],
    "KIF1B": [
        "KIF1B_1773K"
    ],
    "KIF2A": [
        "KIF2A_102K"
    ],
    "KIF2C": [
        "KIF2C_534K"
    ],
    "KIF5B": [
        "KIF5B_240K"
    ],
    "KIFC1": [
        "KIFC1_61K",
        "KIFC1_659K"
    ],
    "KLC1": [
        "KLC1_384K"
    ],
    "KMT2A": [
        "KMT2A_1235K",
        "KMT2A_2314K",
        "KMT2A_2775K"
    ],
    "KMT2B": [
        "KMT2B_1263K",
        "KMT2B_926K"
    ],
    "KMT2C": [
        "KMT2C_2802K",
        "KMT2C_2809K",
        "KMT2C_2814K",
        "KMT2C_2832K",
        "KMT2C_3714K",
        "KMT2C_758K",
        "KMT2C_827K"
    ],
    "KMT2D": [
        "KMT2D_3121K"
    ],
    "KNL1": [
        "KNL1_1100K"
    ],
    "KPNA6": [
        "KPNA6_18K"
    ],
    "KPNB1": [
        "KPNB1_62K",
        "KPNB1_859K"
    ],
    "KRR1": [
        "KRR1_15K"
    ],
    "KRT18": [
        "KRT18_215K",
        "KRT18_417K",
        "KRT18_426K"
    ],
    "KTN1": [
        "KTN1_1140K",
        "KTN1_272K"
    ],
    "LACTB": [
        "LACTB_266K"
    ],
    "LACTB2": [
        "LACTB2_247K"
    ],
    "LAD1": [
        "LAD1_199K"
    ],
    "LAP3": [
        "LAP3_229K"
    ],
    "LARP1": [
        "LARP1_1003K",
        "LARP1_531K"
    ],
    "LARP7": [
        "LARP7_428K",
        "LARP7_574K"
    ],
    "LARS1": [
        "LARS1_914K"
    ],
    "LASP1": [
        "LASP1_50K"
    ],
    "LBR": [
        "LBR_524K"
    ],
    "LCP1": [
        "LCP1_82K"
    ],
    "LDB2": [
        "LDB2_238K"
    ],
    "LDHA": [
        "LDHA_222K"
    ],
    "LDHB": [
        "LDHB_156K"
    ],
    "LGALS3": [
        "LGALS3_176K"
    ],
    "LILRA3": [
        "LILRA3_259K"
    ],
    "LIMA1": [
        "LIMA1_30K"
    ],
    "LMNA": [
        "LMNA_108K",
        "LMNA_457K",
        "LMNA_470K"
    ],
    "LMNB1": [
        "LMNB1_111K",
        "LMNB1_123K",
        "LMNB1_532K"
    ],
    "LMTK3": [
        "LMTK3_972K"
    ],
    "LONP1": [
        "LONP1_232K"
    ],
    "LOX": [
        "LOX_270K"
    ],
    "LPP": [
        "LPP_108K"
    ],
    "LRBA": [
        "LRBA_195K"
    ],
    "LRP1": [
        "LRP1_347K"
    ],
    "LRPPRC": [
        "LRPPRC_1347K",
        "LRPPRC_726K"
    ],
    "LRRC59": [
        "LRRC59_108K",
        "LRRC59_143K",
        "LRRC59_73K"
    ],
    "LSM12": [
        "LSM12_168K"
    ],
    "LSS": [
        "LSS_15K"
    ],
    "LTA4H": [
        "LTA4H_580K"
    ],
    "LTV1": [
        "LTV1_381K"
    ],
    "LUC7L2": [
        "LUC7L2_37K"
    ],
    "LYAR": [
        "LYAR_14K",
        "LYAR_168K"
    ],
    "LYPLA1": [
        "LYPLA1_190K"
    ],
    "MACROH2A1": [
        "MACROH2A1_295K",
        "MACROH2A1_307K"
    ],
    "MAD1L1": [
        "MAD1L1_61K"
    ],
    "MAGOH": [
        "MAGOH_41K"
    ],
    "MAIP1": [
        "MAIP1_276K"
    ],
    "MAML1": [
        "MAML1_563K"
    ],
    "MAN2C1": [
        "MAN2C1_8K"
    ],
    "MANF": [
        "MANF_157K"
    ],
    "MAOA": [
        "MAOA_168K"
    ],
    "MAP1LC3B": [
        "MAP1LC3B_30K"
    ],
    "MAP2K3": [
        "MAP2K3_32K"
    ],
    "MAP3K1": [
        "MAP3K1_188K"
    ],
    "MAP4": [
        "MAP4_1015K",
        "MAP4_283K",
        "MAP4_838K",
        "MAP4_933K",
        "MAP4_946K"
    ],
    "MAP7": [
        "MAP7_101K"
    ],
    "MAPK1": [
        "MAPK1_203K",
        "MAPK1_270K"
    ],
    "MAPK3": [
        "MAPK3_287K"
    ],
    "MAPRE3": [
        "MAPRE3_167K"
    ],
    "MAPT": [
        "MAPT_702K"
    ],
    "MAT2A": [
        "MAT2A_88K"
    ],
    "MATR3": [
        "MATR3_3K",
        "MATR3_524K",
        "MATR3_565K"
    ],
    "MAVS": [
        "MAVS_7K"
    ],
    "MBD2": [
        "MBD2_236K"
    ],
    "MBD3": [
        "MBD3_92K"
    ],
    "MBTD1": [
        "MBTD1_131K"
    ],
    "MCCC1": [
        "MCCC1_295K",
        "MCCC1_663K"
    ],
    "MCM2": [
        "MCM2_447K"
    ],
    "MCM3": [
        "MCM3_314K"
    ],
    "MCM4": [
        "MCM4_409K",
        "MCM4_477K",
        "MCM4_752K",
        "MCM4_858K"
    ],
    "MCM5": [
        "MCM5_141K"
    ],
    "MCM6": [
        "MCM6_407K",
        "MCM6_611K",
        "MCM6_643K",
        "MCM6_654K"
    ],
    "MCM7": [
        "MCM7_308K",
        "MCM7_351K"
    ],
    "MCRS1": [
        "MCRS1_123K",
        "MCRS1_130K",
        "MCRS1_68K"
    ],
    "MCTS1": [
        "MCTS1_18K"
    ],
    "MDC1": [
        "MDC1_812K"
    ],
    "MDH1": [
        "MDH1_110K",
        "MDH1_118K"
    ],
    "MDH2": [
        "MDH2_185K",
        "MDH2_203K",
        "MDH2_301K",
        "MDH2_307K",
        "MDH2_335K"
    ],
    "ME1": [
        "ME1_60K"
    ],
    "ME2": [
        "ME2_26K"
    ],
    "MEAF6": [
        "MEAF6_69K",
        "MEAF6_74K"
    ],
    "MECR": [
        "MECR_267K"
    ],
    "MED1": [
        "MED1_1076K",
        "MED1_1152K",
        "MED1_1173K",
        "MED1_1177K",
        "MED1_152K"
    ],
    "MED12": [
        "MED12_1798K"
    ],
    "MED12L": [
        "MED12L_1230K",
        "MED12L_1759K"
    ],
    "MED14": [
        "MED14_1256K"
    ],
    "MED6": [
        "MED6_236K",
        "MED6_241K"
    ],
    "MEF2D": [
        "MEF2D_511K"
    ],
    "METAP1": [
        "METAP1_311K"
    ],
    "METTL25B": [
        "METTL25B_15K"
    ],
    "MGA": [
        "MGA_2569K"
    ],
    "MGST1": [
        "MGST1_55K"
    ],
    "MIF": [
        "MIF_78K"
    ],
    "MIOS": [
        "MIOS_111K"
    ],
    "MIX23": [
        "MIX23_72K",
        "MIX23_83K"
    ],
    "MKI67": [
        "MKI67_1130K",
        "MKI67_1616K",
        "MKI67_2024K",
        "MKI67_2826K",
        "MKI67_3040K",
        "MKI67_3243K",
        "MKI67_379K",
        "MKI67_46K"
    ],
    "MKLN1": [
        "MKLN1_78K"
    ],
    "MLLT1": [
        "MLLT1_469K"
    ],
    "MMGT1": [
        "MMGT1_77K",
        "MMGT1_79K"
    ],
    "MORC2": [
        "MORC2_819K"
    ],
    "MORF4L1": [
        "MORF4L1_143K"
    ],
    "MOV10": [
        "MOV10_846K"
    ],
    "MPV17": [
        "MPV17_82K"
    ],
    "MRPL12": [
        "MRPL12_150K"
    ],
    "MRPL20": [
        "MRPL20_114K"
    ],
    "MRPL30": [
        "MRPL30_114K"
    ],
    "MRPL35": [
        "MRPL35_152K"
    ],
    "MRPL37": [
        "MRPL37_194K"
    ],
    "MRPL39": [
        "MRPL39_236K",
        "MRPL39_72K"
    ],
    "MRPL44": [
        "MRPL44_99K"
    ],
    "MRPL53": [
        "MRPL53_25K"
    ],
    "MRPS15": [
        "MRPS15_145K"
    ],
    "MRPS18C": [
        "MRPS18C_70K"
    ],
    "MRPS23": [
        "MRPS23_93K"
    ],
    "MRPS35": [
        "MRPS35_187K",
        "MRPS35_208K"
    ],
    "MRPS6": [
        "MRPS6_95K"
    ],
    "MRPS7": [
        "MRPS7_81K"
    ],
    "MRPS9": [
        "MRPS9_287K",
        "MRPS9_325K"
    ],
    "MRTFA": [
        "MRTFA_370K"
    ],
    "MRTFB": [
        "MRTFB_412K",
        "MRTFB_615K",
        "MRTFB_619K",
        "MRTFB_75K"
    ],
    "MRTO4": [
        "MRTO4_109K"
    ],
    "MSH2": [
        "MSH2_567K",
        "MSH2_73K"
    ],
    "MSH6": [
        "MSH6_1296K",
        "MSH6_824K"
    ],
    "MSL1": [
        "MSL1_77K"
    ],
    "MSN": [
        "MSN_143K",
        "MSN_162K",
        "MSN_165K",
        "MSN_3K"
    ],
    "MTA2": [
        "MTA2_460K"
    ],
    "MTAP": [
        "MTAP_147K",
        "MTAP_51K"
    ],
    "MT-ATP8": [
        "MT-ATP8_45K"
    ],
    "MTCH2": [
        "MTCH2_293K"
    ],
    "MTDH": [
        "MTDH_195K",
        "MTDH_248K",
        "MTDH_261K"
    ],
    "MTHFD1": [
        "MTHFD1_21K",
        "MTHFD1_364K",
        "MTHFD1_553K"
    ],
    "MTMR10": [
        "MTMR10_319K"
    ],
    "MTO1": [
        "MTO1_236K"
    ],
    "MTPN": [
        "MTPN_24K",
        "MTPN_90K"
    ],
    "MTRES1": [
        "MTRES1_158K"
    ],
    "MTREX": [
        "MTREX_708K"
    ],
    "MVP": [
        "MVP_33K"
    ],
    "MYBBP1A": [
        "MYBBP1A_874K"
    ],
    "MYDGF": [
        "MYDGF_137K",
        "MYDGF_145K"
    ],
    "MYEF2": [
        "MYEF2_521K"
    ],
    "MYH10": [
        "MYH10_1031K",
        "MYH10_1106K",
        "MYH10_73K",
        "MYH10_767K",
        "MYH10_881K"
    ],
    "MYH7B": [
        "MYH7B_967K"
    ],
    "MYH9": [
        "MYH9_1024K",
        "MYH9_1099K",
        "MYH9_1193K",
        "MYH9_1352K",
        "MYH9_1518K",
        "MYH9_1775K",
        "MYH9_1802K",
        "MYH9_180K",
        "MYH9_228K",
        "MYH9_299K",
        "MYH9_555K",
        "MYH9_565K",
        "MYH9_580K",
        "MYH9_760K",
        "MYH9_833K"
    ],
    "MYL6": [
        "MYL6_56K",
        "MYL6_81K"
    ],
    "MYO1C": [
        "MYO1C_269K",
        "MYO1C_281K",
        "MYO1C_704K"
    ],
    "MYO5C": [
        "MYO5C_1090K"
    ],
    "MYO6": [
        "MYO6_1125K",
        "MYO6_113K",
        "MYO6_550K"
    ],
    "MYOF": [
        "MYOF_14K",
        "MYOF_1507K",
        "MYOF_1936K",
        "MYOF_812K"
    ],
    "NAA10": [
        "NAA10_179K"
    ],
    "NAA15": [
        "NAA15_262K",
        "NAA15_419K",
        "NAA15_665K",
        "NAA15_748K"
    ],
    "NAA30": [
        "NAA30_233K"
    ],
    "NAA50": [
        "NAA50_34K"
    ],
    "NADK2": [
        "NADK2_304K",
        "NADK2_397K",
        "NADK2_76K"
    ],
    "NAMPT": [
        "NAMPT_469K"
    ],
    "NANS": [
        "NANS_243K",
        "NANS_55K",
        "NANS_74K",
        "NANS_79K"
    ],
    "NAP1L1": [
        "NAP1L1_82K"
    ],
    "NAPG": [
        "NAPG_21K"
    ],
    "NARS1": [
        "NARS1_104K",
        "NARS1_60K"
    ],
    "NCAPG": [
        "NCAPG_943K"
    ],
    "NCAPH": [
        "NCAPH_637K"
    ],
    "NCBP3": [
        "NCBP3_487K"
    ],
    "NCKAP1": [
        "NCKAP1_1121K"
    ],
    "NCL": [
        "NCL_116K",
        "NCL_124K",
        "NCL_125K",
        "NCL_132K",
        "NCL_324K",
        "NCL_398K",
        "NCL_403K",
        "NCL_429K",
        "NCL_477K",
        "NCL_577K"
    ],
    "NCOA2": [
        "NCOA2_636K",
        "NCOA2_640K",
        "NCOA2_772K",
        "NCOA2_780K",
        "NCOA2_785K"
    ],
    "NCOA3": [
        "NCOA3_616K",
        "NCOA3_619K",
        "NCOA3_87K"
    ],
    "NCOR1": [
        "NCOR1_1404K"
    ],
    "NCOR2": [
        "NCOR2_1959K",
        "NCOR2_1997K"
    ],
    "NDC1": [
        "NDC1_639K"
    ],
    "NDE1": [
        "NDE1_79K"
    ],
    "NDUFS1": [
        "NDUFS1_607K"
    ],
    "NDUFS6": [
        "NDUFS6_108K"
    ],
    "NDUFV1": [
        "NDUFV1_54K"
    ],
    "NDUFV2": [
        "NDUFV2_68K"
    ],
    "NFIX": [
        "NFIX_99K"
    ],
    "NFKB1": [
        "NFKB1_277K"
    ],
    "NFKB2": [
        "NFKB2_255K",
        "NFKB2_741K"
    ],
    "NFS1": [
        "NFS1_147K"
    ],
    "NIBAN2": [
        "NIBAN2_330K"
    ],
    "NIN": [
        "NIN_786K",
        "NIN_791K"
    ],
    "NIP7": [
        "NIP7_72K"
    ],
    "NIPBL": [
        "NIPBL_634K"
    ],
    "NIPSNAP3A": [
        "NIPSNAP3A_166K"
    ],
    "NKTR": [
        "NKTR_179K"
    ],
    "NMD3": [
        "NMD3_339K"
    ],
    "NME2": [
        "NME2_124K",
        "NME2_26K",
        "NME2_31K",
        "NME2_49K"
    ],
    "NMI": [
        "NMI_36K",
        "NMI_41K"
    ],
    "NNT": [
        "NNT_768K"
    ],
    "NOB1": [
        "NOB1_291K"
    ],
    "NOLC1": [
        "NOLC1_579K"
    ],
    "NOMO3": [
        "NOMO3_61K"
    ],
    "NONO": [
        "NONO_190K",
        "NONO_198K",
        "NONO_243K",
        "NONO_5K",
        "NONO_99K"
    ],
    "NOP16": [
        "NOP16_151K"
    ],
    "NOP2": [
        "NOP2_423K",
        "NOP2_92K"
    ],
    "NOP58": [
        "NOP58_365K"
    ],
    "NOTCH2": [
        "NOTCH2_2095K"
    ],
    "NPAT": [
        "NPAT_257K",
        "NPAT_429K",
        "NPAT_543K"
    ],
    "NPC2": [
        "NPC2_116K"
    ],
    "NPEPL1": [
        "NPEPL1_274K"
    ],
    "NPEPPS": [
        "NPEPPS_261K",
        "NPEPPS_336K"
    ],
    "NPM1": [
        "NPM1_141K",
        "NPM1_150K",
        "NPM1_154K",
        "NPM1_267K",
        "NPM1_273K",
        "NPM1_32K"
    ],
    "NQO1": [
        "NQO1_262K"
    ],
    "NRBP1": [
        "NRBP1_231K"
    ],
    "NSD2": [
        "NSD2_588K"
    ],
    "NSD3": [
        "NSD3_471K",
        "NSD3_532K",
        "NSD3_790K"
    ],
    "NSDHL": [
        "NSDHL_126K"
    ],
    "NSF": [
        "NSF_462K"
    ],
    "NSUN2": [
        "NSUN2_586K",
        "NSUN2_692K",
        "NSUN2_95K"
    ],
    "NT5C2": [
        "NT5C2_21K"
    ],
    "NUCB1": [
        "NUCB1_302K"
    ],
    "NUCKS1": [
        "NUCKS1_52K"
    ],
    "NUDC": [
        "NUDC_196K",
        "NUDC_96K"
    ],
    "NUDT21": [
        "NUDT21_189K",
        "NUDT21_23K"
    ],
    "NUDT5": [
        "NUDT5_205K",
        "NUDT5_33K",
        "NUDT5_42K"
    ],
    "NUDT8": [
        "NUDT8_61K"
    ],
    "NUMA1": [
        "NUMA1_1935K",
        "NUMA1_73K"
    ],
    "NUP133": [
        "NUP133_135K"
    ],
    "NUP153": [
        "NUP153_705K"
    ],
    "NUP188": [
        "NUP188_1721K"
    ],
    "NUP205": [
        "NUP205_1271K"
    ],
    "NUP214": [
        "NUP214_1004K",
        "NUP214_1892K",
        "NUP214_682K"
    ],
    "NUP50": [
        "NUP50_450K"
    ],
    "NUP85": [
        "NUP85_92K"
    ],
    "NUP93": [
        "NUP93_59K",
        "NUP93_664K"
    ],
    "NUP98": [
        "NUP98_1019K",
        "NUP98_563K"
    ],
    "NVL": [
        "NVL_156K"
    ],
    "NXF1": [
        "NXF1_6K"
    ],
    "NXPH4": [
        "NXPH4_94K",
        "NXPH4_98K"
    ],
    "OAT": [
        "OAT_102K"
    ],
    "OCIAD1": [
        "OCIAD1_96K"
    ],
    "OCIAD2": [
        "OCIAD2_29K"
    ],
    "ODR4": [
        "ODR4_158K"
    ],
    "OGDH": [
        "OGDH_389K"
    ],
    "OLA1": [
        "OLA1_180K",
        "OLA1_190K"
    ],
    "OPA1": [
        "OPA1_691K"
    ],
    "OR52E8": [
        "OR52E8_314K"
    ],
    "ORC1": [
        "ORC1_326K"
    ],
    "ORC3": [
        "ORC3_145K",
        "ORC3_523K"
    ],
    "OSBP": [
        "OSBP_230K"
    ],
    "OSBPL9": [
        "OSBPL9_688K"
    ],
    "OSTF1": [
        "OSTF1_3K"
    ],
    "OTUD4": [
        "OTUD4_178K"
    ],
    "OXCT1": [
        "OXCT1_421K"
    ],
    "OXR1": [
        "OXR1_216K"
    ],
    "P4HB": [
        "P4HB_276K",
        "P4HB_328K",
        "P4HB_81K"
    ],
    "PABPC1": [
        "PABPC1_104K",
        "PABPC1_606K"
    ],
    "PABPC4": [
        "PABPC4_104K"
    ],
    "PABPC5": [
        "PABPC5_239K"
    ],
    "PACS1": [
        "PACS1_487K"
    ],
    "PACS2": [
        "PACS2_828K"
    ],
    "PAFAH1B1": [
        "PAFAH1B1_368K"
    ],
    "PAICS": [
        "PAICS_261K",
        "PAICS_53K"
    ],
    "PAK2": [
        "PAK2_191K",
        "PAK2_284K",
        "PAK2_370K"
    ],
    "PAK4": [
        "PAK4_442K"
    ],
    "PALLD": [
        "PALLD_1044K"
    ],
    "PAPSS1": [
        "PAPSS1_248K"
    ],
    "PARK7": [
        "PARK7_62K"
    ],
    "PARN": [
        "PARN_326K"
    ],
    "PARP1": [
        "PARP1_119K",
        "PARP1_425K",
        "PARP1_621K"
    ],
    "PARP8": [
        "PARP8_305K"
    ],
    "PARP9": [
        "PARP9_459K"
    ],
    "PATJ": [
        "PATJ_1027K"
    ],
    "PAWR": [
        "PAWR_227K"
    ],
    "PBK": [
        "PBK_64K"
    ],
    "PCBP1": [
        "PCBP1_115K"
    ],
    "PCBP2": [
        "PCBP2_115K",
        "PCBP2_185K",
        "PCBP2_23K"
    ],
    "PCDH15": [
        "PCDH15_1559K"
    ],
    "PCGF2": [
        "PCGF2_88K"
    ],
    "PCID2": [
        "PCID2_133K"
    ],
    "PCK2": [
        "PCK2_108K"
    ],
    "PCLAF": [
        "PCLAF_5K"
    ],
    "PCMT1": [
        "PCMT1_4K"
    ],
    "PCNP": [
        "PCNP_152K",
        "PCNP_167K"
    ],
    "PCYOX1": [
        "PCYOX1_415K"
    ],
    "PDAP1": [
        "PDAP1_132K",
        "PDAP1_172K"
    ],
    "PDCD11": [
        "PDCD11_1309K",
        "PDCD11_1369K"
    ],
    "PDCD5": [
        "PDCD5_20K"
    ],
    "PDCD6IP": [
        "PDCD6IP_339K",
        "PDCD6IP_501K",
        "PDCD6IP_60K",
        "PDCD6IP_614K"
    ],
    "PDCL": [
        "PDCL_218K"
    ],
    "PDHA1": [
        "PDHA1_149K",
        "PDHA1_313K"
    ],
    "PDHB": [
        "PDHB_184K"
    ],
    "PDHX": [
        "PDHX_194K"
    ],
    "PDIA3": [
        "PDIA3_218K",
        "PDIA3_274K",
        "PDIA3_366K",
        "PDIA3_82K"
    ],
    "PDIA4": [
        "PDIA4_637K"
    ],
    "PDIA6": [
        "PDIA6_85K"
    ],
    "PDLIM1": [
        "PDLIM1_246K"
    ],
    "PDLIM7": [
        "PDLIM7_238K"
    ],
    "PDS5A": [
        "PDS5A_1136K",
        "PDS5A_1211K",
        "PDS5A_974K"
    ],
    "PDS5B": [
        "PDS5B_964K"
    ],
    "PDXDC1": [
        "PDXDC1_358K"
    ],
    "PEBP1": [
        "PEBP1_150K"
    ],
    "PES1": [
        "PES1_152K",
        "PES1_49K",
        "PES1_98K"
    ],
    "PFAS": [
        "PFAS_683K"
    ],
    "PFDN5": [
        "PFDN5_124K",
        "PFDN5_55K"
    ],
    "PFKL": [
        "PFKL_616K"
    ],
    "PFKP": [
        "PFKP_395K",
        "PFKP_688K"
    ],
    "PFN1": [
        "PFN1_105K",
        "PFN1_108K",
        "PFN1_91K"
    ],
    "PFN2": [
        "PFN2_91K"
    ],
    "PGAM1": [
        "PGAM1_100K",
        "PGAM1_106K"
    ],
    "PGAM5": [
        "PGAM5_144K"
    ],
    "PGD": [
        "PGD_248K",
        "PGD_38K"
    ],
    "PGK1": [
        "PGK1_30K",
        "PGK1_353K"
    ],
    "PGLS": [
        "PGLS_254K"
    ],
    "PGM3": [
        "PGM3_177K",
        "PGM3_350K"
    ],
    "PHAX": [
        "PHAX_339K"
    ],
    "PHB2": [
        "PHB2_244K"
    ],
    "PHF10": [
        "PHF10_195K"
    ],
    "PHF3": [
        "PHF3_190K",
        "PHF3_1967K",
        "PHF3_1969K"
    ],
    "PHF5A": [
        "PHF5A_3K",
        "PHF5A_95K"
    ],
    "PHF6": [
        "PHF6_299K"
    ],
    "PHGDH": [
        "PHGDH_58K"
    ],
    "PHIP": [
        "PHIP_1533K",
        "PHIP_1542K",
        "PHIP_1550K",
        "PHIP_1602K"
    ],
    "PHLDB1": [
        "PHLDB1_1293K"
    ],
    "PHYH": [
        "PHYH_108K",
        "PHYH_120K"
    ],
    "PIAS4": [
        "PIAS4_125K"
    ],
    "PICALM": [
        "PICALM_24K"
    ],
    "PIN1": [
        "PIN1_63K"
    ],
    "PIP4K2C": [
        "PIP4K2C_101K",
        "PIP4K2C_393K"
    ],
    "PIP5K1A": [
        "PIP5K1A_140K"
    ],
    "PIR": [
        "PIR_181K"
    ],
    "PITPNA": [
        "PITPNA_116K",
        "PITPNA_67K"
    ],
    "PITRM1": [
        "PITRM1_943K"
    ],
    "PKM": [
        "PKM_115K",
        "PKM_135K",
        "PKM_270K",
        "PKM_322K",
        "PKM_433K",
        "PKM_498K",
        "PKM_66K"
    ],
    "PLAA": [
        "PLAA_112K",
        "PLAA_259K",
        "PLAA_529K",
        "PLAA_652K"
    ],
    "PLCB3": [
        "PLCB3_173K"
    ],
    "PLEC": [
        "PLEC_1725K",
        "PLEC_191K",
        "PLEC_1986K",
        "PLEC_2025K",
        "PLEC_2306K",
        "PLEC_338K",
        "PLEC_3968K"
    ],
    "PLEKHF2": [
        "PLEKHF2_107K"
    ],
    "PLPBP": [
        "PLPBP_125K"
    ],
    "PLS3": [
        "PLS3_52K",
        "PLS3_537K"
    ],
    "PLSCR5": [
        "PLSCR5_91K"
    ],
    "PMS2": [
        "PMS2_210K"
    ],
    "PNPO": [
        "PNPO_163K"
    ],
    "POGZ": [
        "POGZ_1273K",
        "POGZ_871K"
    ],
    "POLD3": [
        "POLD3_390K"
    ],
    "POLDIP3": [
        "POLDIP3_404K"
    ],
    "POLR1D": [
        "POLR1D_15K"
    ],
    "POLR2A": [
        "POLR2A_710K"
    ],
    "POLR2B": [
        "POLR2B_1143K",
        "POLR2B_934K"
    ],
    "POLR2J": [
        "POLR2J_26K"
    ],
    "POLR3A": [
        "POLR3A_398K"
    ],
    "POM121B": [
        "POM121B_321K"
    ],
    "POP4": [
        "POP4_2K"
    ],
    "POR": [
        "POR_358K"
    ],
    "PPA1": [
        "PPA1_22K"
    ],
    "PPAT": [
        "PPAT_62K"
    ],
    "PPCS": [
        "PPCS_46K"
    ],
    "PPIA": [
        "PPIA_125K",
        "PPIA_131K",
        "PPIA_31K",
        "PPIA_44K",
        "PPIA_49K"
    ],
    "PPIB": [
        "PPIB_116K",
        "PPIB_131K",
        "PPIB_165K",
        "PPIB_215K",
        "PPIB_89K"
    ],
    "PPID": [
        "PPID_111K"
    ],
    "PPIF": [
        "PPIF_190K",
        "PPIF_73K",
        "PPIF_86K",
        "PPIF_91K"
    ],
    "PPIG": [
        "PPIG_180K",
        "PPIG_52K"
    ],
    "PPM1B": [
        "PPM1B_90K"
    ],
    "PPM1G": [
        "PPM1G_339K",
        "PPM1G_383K"
    ],
    "PPME1": [
        "PPME1_6K"
    ],
    "PPP1CA": [
        "PPP1CA_141K",
        "PPP1CA_26K"
    ],
    "PPP1CB": [
        "PPP1CB_25K",
        "PPP1CB_303K"
    ],
    "PPP1R12A": [
        "PPP1R12A_197K"
    ],
    "PPP1R2B": [
        "PPP1R2B_18K"
    ],
    "PPP1R7": [
        "PPP1R7_101K"
    ],
    "PPP2CA": [
        "PPP2CA_29K"
    ],
    "PPP2R1A": [
        "PPP2R1A_280K",
        "PPP2R1A_475K",
        "PPP2R1A_542K"
    ],
    "PPP2R5C": [
        "PPP2R5C_183K"
    ],
    "PPP3CC": [
        "PPP3CC_43K"
    ],
    "PPP4R2": [
        "PPP4R2_231K"
    ],
    "PPP6R3": [
        "PPP6R3_816K"
    ],
    "PRC1": [
        "PRC1_342K"
    ],
    "PRCC": [
        "PRCC_250K"
    ],
    "PRDX1": [
        "PRDX1_178K"
    ],
    "PRDX2": [
        "PRDX2_196K"
    ],
    "PREX1": [
        "PREX1_1547K",
        "PREX1_1632K",
        "PREX1_216K",
        "PREX1_486K",
        "PREX1_537K",
        "PREX1_926K"
    ],
    "PRKACA": [
        "PRKACA_48K"
    ],
    "PRKAR2B": [
        "PRKAR2B_137K",
        "PRKAR2B_150K"
    ],
    "PRKCI": [
        "PRKCI_494K"
    ],
    "PRKCSH": [
        "PRKCSH_196K"
    ],
    "PRKDC": [
        "PRKDC_1057K",
        "PRKDC_1141K",
        "PRKDC_1612K",
        "PRKDC_2418K",
        "PRKDC_2694K",
        "PRKDC_2829K",
        "PRKDC_3552K",
        "PRKDC_3642K",
        "PRKDC_3710K",
        "PRKDC_689K",
        "PRKDC_692K",
        "PRKDC_838K"
    ],
    "PRMT1": [
        "PRMT1_134K",
        "PRMT1_145K"
    ],
    "PRMT3": [
        "PRMT3_477K"
    ],
    "PRPF19": [
        "PRPF19_179K",
        "PRPF19_428K",
        "PRPF19_64K"
    ],
    "PRPF3": [
        "PRPF3_495K"
    ],
    "PRPF31": [
        "PRPF31_438K"
    ],
    "PRPF4": [
        "PRPF4_216K",
        "PRPF4_27K"
    ],
    "PRPF40A": [
        "PRPF40A_196K",
        "PRPF40A_925K"
    ],
    "PRPF40B": [
        "PRPF40B_148K"
    ],
    "PRPF6": [
        "PRPF6_585K"
    ],
    "PRPF8": [
        "PRPF8_1144K",
        "PRPF8_2049K",
        "PRPF8_2108K",
        "PRPF8_769K"
    ],
    "PRPSAP1": [
        "PRPSAP1_238K"
    ],
    "PRR14L": [
        "PRR14L_1328K"
    ],
    "PRRC2A": [
        "PRRC2A_29K",
        "PRRC2A_49K"
    ],
    "PRRC2C": [
        "PRRC2C_2890K",
        "PRRC2C_29K",
        "PRRC2C_47K"
    ],
    "PRRX1": [
        "PRRX1_160K"
    ],
    "PSIP1": [
        "PSIP1_16K",
        "PSIP1_360K",
        "PSIP1_364K",
        "PSIP1_407K"
    ],
    "PSMA1": [
        "PSMA1_115K",
        "PSMA1_41K"
    ],
    "PSMA2": [
        "PSMA2_171K",
        "PSMA2_53K"
    ],
    "PSMA3": [
        "PSMA3_110K",
        "PSMA3_43K",
        "PSMA3_57K"
    ],
    "PSMA4": [
        "PSMA4_199K",
        "PSMA4_239K"
    ],
    "PSMA5": [
        "PSMA5_187K"
    ],
    "PSMA6": [
        "PSMA6_104K",
        "PSMA6_45K"
    ],
    "PSMB1": [
        "PSMB1_104K",
        "PSMB1_228K",
        "PSMB1_77K"
    ],
    "PSMB2": [
        "PSMB2_29K"
    ],
    "PSMB3": [
        "PSMB3_17K"
    ],
    "PSMB5": [
        "PSMB5_91K"
    ],
    "PSMC1": [
        "PSMC1_423K",
        "PSMC1_98K"
    ],
    "PSMC2": [
        "PSMC2_110K",
        "PSMC2_222K"
    ],
    "PSMC3": [
        "PSMC3_233K",
        "PSMC3_245K",
        "PSMC3_56K"
    ],
    "PSMC4": [
        "PSMC4_212K"
    ],
    "PSMC5": [
        "PSMC5_196K"
    ],
    "PSMC6": [
        "PSMC6_180K",
        "PSMC6_322K",
        "PSMC6_383K"
    ],
    "PSMD1": [
        "PSMD1_354K",
        "PSMD1_720K"
    ],
    "PSMD11": [
        "PSMD11_32K",
        "PSMD11_358K"
    ],
    "PSMD13": [
        "PSMD13_105K",
        "PSMD13_115K",
        "PSMD13_298K",
        "PSMD13_329K"
    ],
    "PSMD14": [
        "PSMD14_253K"
    ],
    "PSMD2": [
        "PSMD2_350K"
    ],
    "PSMD3": [
        "PSMD3_404K",
        "PSMD3_503K"
    ],
    "PSMD4": [
        "PSMD4_365K",
        "PSMD4_368K",
        "PSMD4_40K",
        "PSMD4_74K",
        "PSMD4_98K"
    ],
    "PSMD6": [
        "PSMD6_130K",
        "PSMD6_165K",
        "PSMD6_349K"
    ],
    "PSMD7": [
        "PSMD7_103K",
        "PSMD7_199K",
        "PSMD7_204K"
    ],
    "PSMD8": [
        "PSMD8_138K"
    ],
    "PSME2": [
        "PSME2_156K",
        "PSME2_180K"
    ],
    "PSME3": [
        "PSME3_14K",
        "PSME3_6K"
    ],
    "PSMG1": [
        "PSMG1_193K",
        "PSMG1_264K"
    ],
    "PSMG2": [
        "PSMG2_188K"
    ],
    "PSPC1": [
        "PSPC1_251K",
        "PSPC1_380K"
    ],
    "PTBP1": [
        "PTBP1_137K",
        "PTBP1_259K",
        "PTBP1_368K",
        "PTBP1_402K",
        "PTBP1_410K"
    ],
    "PTBP2": [
        "PTBP2_137K",
        "PTBP2_411K"
    ],
    "PTBP3": [
        "PTBP3_137K",
        "PTBP3_423K",
        "PTBP3_431K"
    ],
    "PTGES3": [
        "PTGES3_33K",
        "PTGES3_35K",
        "PTGES3_65K"
    ],
    "PTGFRN": [
        "PTGFRN_435K"
    ],
    "PTK2": [
        "PTK2_78K"
    ],
    "PTMA": [
        "PTMA_103K"
    ],
    "PTPA": [
        "PTPA_331K"
    ],
    "PTPN11": [
        "PTPN11_280K",
        "PTPN11_35K",
        "PTPN11_492K"
    ],
    "PTPN12": [
        "PTPN12_65K"
    ],
    "PTPN23": [
        "PTPN23_1220K"
    ],
    "PUF60": [
        "PUF60_253K",
        "PUF60_267K"
    ],
    "PUM3": [
        "PUM3_324K"
    ],
    "PURB": [
        "PURB_120K"
    ],
    "PWP2": [
        "PWP2_700K"
    ],
    "PYGL": [
        "PYGL_787K"
    ],
    "QARS1": [
        "QARS1_25K"
    ],
    "RAB10": [
        "RAB10_49K"
    ],
    "RAB11B": [
        "RAB11B_24K"
    ],
    "RAB11FIP1": [
        "RAB11FIP1_218K",
        "RAB11FIP1_223K"
    ],
    "RAB13": [
        "RAB13_71K"
    ],
    "RAB14": [
        "RAB14_34K"
    ],
    "RAB1B": [
        "RAB1B_122K"
    ],
    "RAB24": [
        "RAB24_20K"
    ],
    "RAB31": [
        "RAB31_18K"
    ],
    "RAB34": [
        "RAB34_74K"
    ],
    "RAB3GAP2": [
        "RAB3GAP2_493K"
    ],
    "RAB43": [
        "RAB43_39K"
    ],
    "RAB5A": [
        "RAB5A_183K"
    ],
    "RAB5C": [
        "RAB5C_184K"
    ],
    "RAB7A": [
        "RAB7A_146K"
    ],
    "RAB8B": [
        "RAB8B_3K"
    ],
    "RAC1": [
        "RAC1_166K"
    ],
    "RACK1": [
        "RACK1_175K",
        "RACK1_185K"
    ],
    "RAD23B": [
        "RAD23B_36K"
    ],
    "RAD50": [
        "RAD50_1068K",
        "RAD50_992K"
    ],
    "RAD9A": [
        "RAD9A_2K"
    ],
    "RAE1": [
        "RAE1_212K"
    ],
    "RAI1": [
        "RAI1_466K",
        "RAI1_774K"
    ],
    "RALY": [
        "RALY_13K",
        "RALY_183K"
    ],
    "RAN": [
        "RAN_123K",
        "RAN_134K",
        "RAN_142K",
        "RAN_23K",
        "RAN_37K",
        "RAN_99K"
    ],
    "RANGAP1": [
        "RANGAP1_524K"
    ],
    "RAPH1": [
        "RAPH1_471K"
    ],
    "RARS1": [
        "RARS1_143K",
        "RARS1_287K"
    ],
    "RAVER1": [
        "RAVER1_434K"
    ],
    "RBBP4": [
        "RBBP4_4K"
    ],
    "RBBP7": [
        "RBBP7_119K"
    ],
    "RBIS": [
        "RBIS_21K"
    ],
    "RBM10": [
        "RBM10_920K"
    ],
    "RBM14": [
        "RBM14_149K",
        "RBM14_164K"
    ],
    "RBM17": [
        "RBM17_21K",
        "RBM17_256K",
        "RBM17_276K",
        "RBM17_41K"
    ],
    "RBM25": [
        "RBM25_462K",
        "RBM25_739K"
    ],
    "RBM26": [
        "RBM26_747K"
    ],
    "RBM27": [
        "RBM27_805K"
    ],
    "RBM28": [
        "RBM28_213K",
        "RBM28_473K"
    ],
    "RBM3": [
        "RBM3_84K"
    ],
    "RBM4B": [
        "RBM4B_139K"
    ],
    "RBMS1": [
        "RBMS1_97K"
    ],
    "RBMX": [
        "RBMX_30K",
        "RBMX_80K"
    ],
    "RBPJ": [
        "RBPJ_175K"
    ],
    "RCC1": [
        "RCC1_232K"
    ],
    "RCC2": [
        "RCC2_368K",
        "RCC2_470K",
        "RCC2_77K"
    ],
    "RCOR1": [
        "RCOR1_242K"
    ],
    "RDX": [
        "RDX_162K"
    ],
    "REEP5": [
        "REEP5_16K",
        "REEP5_29K"
    ],
    "RELA": [
        "RELA_122K",
        "RELA_310K"
    ],
    "REPIN1": [
        "REPIN1_527K"
    ],
    "REPS1": [
        "REPS1_105K"
    ],
    "REXO2": [
        "REXO2_103K"
    ],
    "RFC2": [
        "RFC2_163K",
        "RFC2_192K"
    ],
    "RFC4": [
        "RFC4_124K"
    ],
    "RFX7": [
        "RFX7_607K"
    ],
    "RHOA": [
        "RHOA_162K"
    ],
    "RHOC": [
        "RHOC_162K"
    ],
    "RHOT1": [
        "RHOT1_92K"
    ],
    "RHOT2": [
        "RHOT2_315K"
    ],
    "RIDA": [
        "RIDA_101K",
        "RIDA_117K",
        "RIDA_60K"
    ],
    "RING1": [
        "RING1_285K"
    ],
    "RMDN1": [
        "RMDN1_156K"
    ],
    "RNASEL": [
        "RNASEL_684K"
    ],
    "RNF40": [
        "RNF40_250K"
    ],
    "ROCK1": [
        "ROCK1_639K",
        "ROCK1_701K"
    ],
    "ROCK2": [
        "ROCK2_323K"
    ],
    "RPA1": [
        "RPA1_167K",
        "RPA1_259K",
        "RPA1_331K"
    ],
    "RPA2": [
        "RPA2_235K"
    ],
    "RPGRIP1": [
        "RPGRIP1_568K"
    ],
    "RPL10": [
        "RPL10_13K",
        "RPL10_208K",
        "RPL10_78K",
        "RPL10_82K"
    ],
    "RPL10A": [
        "RPL10A_130K",
        "RPL10A_152K"
    ],
    "RPL11": [
        "RPL11_144K",
        "RPL11_154K",
        "RPL11_52K",
        "RPL11_78K"
    ],
    "RPL12": [
        "RPL12_54K"
    ],
    "RPL13": [
        "RPL13_105K",
        "RPL13_123K"
    ],
    "RPL13A": [
        "RPL13A_197K"
    ],
    "RPL15": [
        "RPL15_56K",
        "RPL15_83K"
    ],
    "RPL17": [
        "RPL17_13K",
        "RPL17_27K",
        "RPL17_74K"
    ],
    "RPL18": [
        "RPL18_164K",
        "RPL18_19K",
        "RPL18_99K"
    ],
    "RPL18A": [
        "RPL18A_11K",
        "RPL18A_41K",
        "RPL18A_76K"
    ],
    "RPL19": [
        "RPL19_128K"
    ],
    "RPL21": [
        "RPL21_21K",
        "RPL21_43K",
        "RPL21_50K",
        "RPL21_97K"
    ],
    "RPL22": [
        "RPL22_107K",
        "RPL22_69K"
    ],
    "RPL23A": [
        "RPL23A_106K",
        "RPL23A_70K"
    ],
    "RPL24": [
        "RPL24_27K",
        "RPL24_2K"
    ],
    "RPL26": [
        "RPL26_63K",
        "RPL26_69K"
    ],
    "RPL26L1": [
        "RPL26L1_136K"
    ],
    "RPL27": [
        "RPL27_128K",
        "RPL27_27K",
        "RPL27_93K"
    ],
    "RPL27A": [
        "RPL27A_138K",
        "RPL27A_55K",
        "RPL27A_59K",
        "RPL27A_94K"
    ],
    "RPL28": [
        "RPL28_19K"
    ],
    "RPL29": [
        "RPL29_103K"
    ],
    "RPL3": [
        "RPL3_103K",
        "RPL3_115K",
        "RPL3_120K",
        "RPL3_272K",
        "RPL3_286K",
        "RPL3_300K"
    ],
    "RPL30": [
        "RPL30_32K"
    ],
    "RPL31": [
        "RPL31_70K",
        "RPL31_75K"
    ],
    "RPL32": [
        "RPL32_106K",
        "RPL32_67K"
    ],
    "RPL34": [
        "RPL34_19K",
        "RPL34_43K"
    ],
    "RPL35": [
        "RPL35_97K"
    ],
    "RPL35A": [
        "RPL35A_45K"
    ],
    "RPL36": [
        "RPL36_13K"
    ],
    "RPL36A": [
        "RPL36A_17K",
        "RPL36A_22K",
        "RPL36A_30K",
        "RPL36A_6K",
        "RPL36A_89K"
    ],
    "RPL36AL": [
        "RPL36AL_30K"
    ],
    "RPL37": [
        "RPL37_14K",
        "RPL37_25K",
        "RPL37_31K"
    ],
    "RPL37A": [
        "RPL37A_44K"
    ],
    "RPL38": [
        "RPL38_57K"
    ],
    "RPL4": [
        "RPL4_106K",
        "RPL4_14K",
        "RPL4_20K",
        "RPL4_274K",
        "RPL4_333K",
        "RPL4_353K",
        "RPL4_364K"
    ],
    "RPL5": [
        "RPL5_158K",
        "RPL5_178K",
        "RPL5_197K",
        "RPL5_220K",
        "RPL5_241K",
        "RPL5_27K"
    ],
    "RPL6": [
        "RPL6_210K"
    ],
    "RPL7A": [
        "RPL7A_245K",
        "RPL7A_37K"
    ],
    "RPL8": [
        "RPL8_144K",
        "RPL8_60K"
    ],
    "RPL9": [
        "RPL9_59K"
    ],
    "RPLP0": [
        "RPLP0_10K",
        "RPLP0_57K"
    ],
    "RPN1": [
        "RPN1_187K",
        "RPN1_538K",
        "RPN1_564K"
    ],
    "RPN2": [
        "RPN2_311K",
        "RPN2_627K"
    ],
    "RPRD2": [
        "RPRD2_1024K"
    ],
    "RPS10": [
        "RPS10_107K",
        "RPS10_31K"
    ],
    "RPS11": [
        "RPS11_107K",
        "RPS11_136K",
        "RPS11_38K",
        "RPS11_45K",
        "RPS11_58K"
    ],
    "RPS13": [
        "RPS13_9K"
    ],
    "RPS15": [
        "RPS15_77K"
    ],
    "RPS15A": [
        "RPS15A_60K"
    ],
    "RPS16": [
        "RPS16_4K",
        "RPS16_73K"
    ],
    "RPS17": [
        "RPS17_49K",
        "RPS17_59K"
    ],
    "RPS18": [
        "RPS18_137K"
    ],
    "RPS19": [
        "RPS19_29K",
        "RPS19_77K"
    ],
    "RPS2": [
        "RPS2_263K",
        "RPS2_275K",
        "RPS2_65K"
    ],
    "RPS20": [
        "RPS20_75K"
    ],
    "RPS23": [
        "RPS23_25K",
        "RPS23_48K"
    ],
    "RPS24": [
        "RPS24_37K"
    ],
    "RPS25": [
        "RPS25_25K",
        "RPS25_52K",
        "RPS25_94K"
    ],
    "RPS27": [
        "RPS27_16K"
    ],
    "RPS27A": [
        "RPS27A_11K",
        "RPS27A_143K",
        "RPS27A_152K",
        "RPS27A_6K"
    ],
    "RPS27L": [
        "RPS27L_16K"
    ],
    "RPS28": [
        "RPS28_16K"
    ],
    "RPS3": [
        "RPS3_108K",
        "RPS3_187K"
    ],
    "RPS3A": [
        "RPS3A_46K",
        "RPS3A_56K"
    ],
    "RPS4X": [
        "RPS4X_106K",
        "RPS4X_134K",
        "RPS4X_16K",
        "RPS4X_62K",
        "RPS4X_71K"
    ],
    "RPS6": [
        "RPS6_149K",
        "RPS6_203K",
        "RPS6_2K",
        "RPS6_79K"
    ],
    "RPS7": [
        "RPS7_160K",
        "RPS7_169K"
    ],
    "RPS8": [
        "RPS8_37K"
    ],
    "RPS9": [
        "RPS9_121K",
        "RPS9_155K"
    ],
    "RRAGA": [
        "RRAGA_15K"
    ],
    "RRBP1": [
        "RRBP1_1098K"
    ],
    "RRM2": [
        "RRM2_46K",
        "RRM2_59K"
    ],
    "RRP1": [
        "RRP1_205K"
    ],
    "RRP15": [
        "RRP15_179K"
    ],
    "RRP7A": [
        "RRP7A_149K"
    ],
    "RRS1": [
        "RRS1_184K"
    ],
    "RSF1": [
        "RSF1_1050K",
        "RSF1_1061K",
        "RSF1_1294K",
        "RSF1_277K",
        "RSF1_456K"
    ],
    "RSL1D1": [
        "RSL1D1_188K",
        "RSL1D1_468K",
        "RSL1D1_48K"
    ],
    "RSL24D1": [
        "RSL24D1_88K"
    ],
    "RSU1": [
        "RSU1_89K"
    ],
    "RTCA": [
        "RTCA_163K"
    ],
    "RTCB": [
        "RTCB_17K"
    ],
    "RTF2": [
        "RTF2_245K",
        "RTF2_86K"
    ],
    "RTKN": [
        "RTKN_216K"
    ],
    "RTN3": [
        "RTN3_998K"
    ],
    "RTRAF": [
        "RTRAF_41K"
    ],
    "RUFY3": [
        "RUFY3_405K"
    ],
    "RUVBL2": [
        "RUVBL2_197K",
        "RUVBL2_234K",
        "RUVBL2_427K",
        "RUVBL2_9K"
    ],
    "S100A10": [
        "S100A10_28K",
        "S100A10_57K"
    ],
    "S100A11": [
        "S100A11_27K",
        "S100A11_3K"
    ],
    "S100A16": [
        "S100A16_25K",
        "S100A16_30K",
        "S100A16_35K"
    ],
    "S100A6": [
        "S100A6_26K",
        "S100A6_47K"
    ],
    "SACM1L": [
        "SACM1L_456K"
    ],
    "SAE1": [
        "SAE1_148K",
        "SAE1_183K",
        "SAE1_195K"
    ],
    "SAFB": [
        "SAFB_294K",
        "SAFB_423K",
        "SAFB_469K",
        "SAFB_578K"
    ],
    "SAMD9L": [
        "SAMD9L_378K"
    ],
    "SAMM50": [
        "SAMM50_74K"
    ],
    "SAP30BP": [
        "SAP30BP_220K"
    ],
    "SARNP": [
        "SARNP_17K"
    ],
    "SARS1": [
        "SARS1_57K",
        "SARS1_62K"
    ],
    "SART1": [
        "SART1_302K",
        "SART1_666K"
    ],
    "SART3": [
        "SART3_130K"
    ],
    "SBDS": [
        "SBDS_145K",
        "SBDS_33K",
        "SBDS_35K"
    ],
    "SBNO1": [
        "SBNO1_442K"
    ],
    "SCAF1": [
        "SCAF1_1254K"
    ],
    "SCIN": [
        "SCIN_345K",
        "SCIN_364K",
        "SCIN_622K"
    ],
    "SCP2": [
        "SCP2_453K"
    ],
    "SCRN1": [
        "SCRN1_319K"
    ],
    "SCYL2": [
        "SCYL2_493K"
    ],
    "SDAD1": [
        "SDAD1_621K"
    ],
    "SDCBP": [
        "SDCBP_119K"
    ],
    "SDHA": [
        "SDHA_250K",
        "SDHA_517K",
        "SDHA_547K",
        "SDHA_550K",
        "SDHA_624K"
    ],
    "SDHB": [
        "SDHB_80K"
    ],
    "SDSL": [
        "SDSL_323K"
    ],
    "SEC11B": [
        "SEC11B_101K"
    ],
    "SEC16A": [
        "SEC16A_324K"
    ],
    "SEC23A": [
        "SEC23A_392K"
    ],
    "SEC23B": [
        "SEC23B_331K"
    ],
    "SEC31A": [
        "SEC31A_120K",
        "SEC31A_647K"
    ],
    "SEC63": [
        "SEC63_407K"
    ],
    "SELENBP1": [
        "SELENBP1_279K",
        "SELENBP1_93K"
    ],
    "SELENOH": [
        "SELENOH_20K"
    ],
    "SEPTIN11": [
        "SEPTIN11_190K"
    ],
    "SEPTIN2": [
        "SEPTIN2_174K",
        "SEPTIN2_318K"
    ],
    "SEPTIN8": [
        "SEPTIN8_193K",
        "SEPTIN8_381K"
    ],
    "SEPTIN9": [
        "SEPTIN9_320K",
        "SEPTIN9_338K",
        "SEPTIN9_435K",
        "SEPTIN9_69K"
    ],
    "SERBP1": [
        "SERBP1_211K",
        "SERBP1_303K",
        "SERBP1_327K",
        "SERBP1_329K"
    ],
    "SERPINB6": [
        "SERPINB6_191K"
    ],
    "SERPINH1": [
        "SERPINH1_160K",
        "SERPINH1_287K"
    ],
    "SET": [
        "SET_132K",
        "SET_167K"
    ],
    "SF1": [
        "SF1_165K"
    ],
    "SF3A1": [
        "SF3A1_717K"
    ],
    "SF3A2": [
        "SF3A2_10K"
    ],
    "SF3A3": [
        "SF3A3_264K",
        "SF3A3_291K"
    ],
    "SF3B1": [
        "SF3B1_1025K",
        "SF3B1_6K"
    ],
    "SF3B3": [
        "SF3B3_109K"
    ],
    "SFN": [
        "SFN_68K"
    ],
    "SFPQ": [
        "SFPQ_217K",
        "SFPQ_232K",
        "SFPQ_332K"
    ],
    "SFXN3": [
        "SFXN3_169K"
    ],
    "SGO2": [
        "SGO2_1000K",
        "SGO2_1002K"
    ],
    "SGPL1": [
        "SGPL1_431K"
    ],
    "SGTA": [
        "SGTA_160K",
        "SGTA_95K"
    ],
    "SH3BGRL": [
        "SH3BGRL_17K"
    ],
    "SH3GLB1": [
        "SH3GLB1_53K"
    ],
    "SHMT1": [
        "SHMT1_386K"
    ],
    "SHMT2": [
        "SHMT2_103K",
        "SHMT2_269K",
        "SHMT2_280K",
        "SHMT2_302K",
        "SHMT2_356K",
        "SHMT2_409K",
        "SHMT2_469K"
    ],
    "SHQ1": [
        "SHQ1_259K",
        "SHQ1_355K"
    ],
    "SHTN1": [
        "SHTN1_335K"
    ],
    "SIN3A": [
        "SIN3A_155K",
        "SIN3A_865K"
    ],
    "SKP1": [
        "SKP1_66K"
    ],
    "SLC25A1": [
        "SLC25A1_277K",
        "SLC25A1_97K"
    ],
    "SLC25A24": [
        "SLC25A24_228K",
        "SLC25A24_320K",
        "SLC25A24_336K",
        "SLC25A24_437K"
    ],
    "SLC25A4": [
        "SLC25A4_166K",
        "SLC25A4_96K"
    ],
    "SLC25A5": [
        "SLC25A5_105K",
        "SLC25A5_147K",
        "SLC25A5_163K",
        "SLC25A5_166K",
        "SLC25A5_272K",
        "SLC25A5_33K",
        "SLC25A5_92K",
        "SLC25A5_96K"
    ],
    "SLC25A6": [
        "SLC25A6_147K",
        "SLC25A6_166K",
        "SLC25A6_199K"
    ],
    "SLC27A2": [
        "SLC27A2_141K"
    ],
    "SLC27A4": [
        "SLC27A4_590K"
    ],
    "SLC35E1": [
        "SLC35E1_345K"
    ],
    "SLC3A2": [
        "SLC3A2_255K",
        "SLC3A2_257K",
        "SLC3A2_266K"
    ],
    "SLC4A1AP": [
        "SLC4A1AP_737K"
    ],
    "SLC9A3R1": [
        "SLC9A3R1_159K",
        "SLC9A3R1_172K",
        "SLC9A3R1_174K",
        "SLC9A3R1_34K"
    ],
    "SLK": [
        "SLK_1019K"
    ],
    "SLTM": [
        "SLTM_401K"
    ],
    "SMARCA4": [
        "SMARCA4_1623K",
        "SMARCA4_867K",
        "SMARCA4_94K"
    ],
    "SMARCA5": [
        "SMARCA5_440K",
        "SMARCA5_647K",
        "SMARCA5_799K"
    ],
    "SMARCAL1": [
        "SMARCAL1_225K"
    ],
    "SMARCC1": [
        "SMARCC1_103K",
        "SMARCC1_303K",
        "SMARCC1_345K",
        "SMARCC1_346K",
        "SMARCC1_354K",
        "SMARCC1_61K"
    ],
    "SMARCC2": [
        "SMARCC2_101K",
        "SMARCC2_275K",
        "SMARCC2_33K",
        "SMARCC2_694K",
        "SMARCC2_75K",
        "SMARCC2_874K"
    ],
    "SMARCD2": [
        "SMARCD2_514K"
    ],
    "SMC1A": [
        "SMC1A_324K",
        "SMC1A_373K",
        "SMC1A_540K",
        "SMC1A_637K",
        "SMC1A_723K"
    ],
    "SMC2": [
        "SMC2_312K",
        "SMC2_919K"
    ],
    "SMC3": [
        "SMC3_105K",
        "SMC3_106K"
    ],
    "SMC4": [
        "SMC4_587K"
    ],
    "SMG7": [
        "SMG7_122K"
    ],
    "SMTN": [
        "SMTN_506K"
    ],
    "SMU1": [
        "SMU1_214K"
    ],
    "SMYD5": [
        "SMYD5_34K"
    ],
    "SND1": [
        "SND1_641K",
        "SND1_886K"
    ],
    "SNF8": [
        "SNF8_53K"
    ],
    "SNRNP200": [
        "SNRNP200_1552K",
        "SNRNP200_487K"
    ],
    "SNRNP40": [
        "SNRNP40_18K"
    ],
    "SNRNP70": [
        "SNRNP70_130K",
        "SNRNP70_162K"
    ],
    "SNRPA": [
        "SNRPA_114K",
        "SNRPA_88K",
        "SNRPA_98K"
    ],
    "SNRPA1": [
        "SNRPA1_179K",
        "SNRPA1_221K",
        "SNRPA1_67K"
    ],
    "SNRPB2": [
        "SNRPB2_85K"
    ],
    "SNRPD2": [
        "SNRPD2_79K",
        "SNRPD2_8K"
    ],
    "SNU13": [
        "SNU13_44K"
    ],
    "SNW1": [
        "SNW1_255K",
        "SNW1_441K"
    ],
    "SNX1": [
        "SNX1_490K"
    ],
    "SNX2": [
        "SNX2_116K",
        "SNX2_248K",
        "SNX2_447K"
    ],
    "SNX27": [
        "SNX27_48K"
    ],
    "SNX3": [
        "SNX3_54K"
    ],
    "SNX6": [
        "SNX6_276K",
        "SNX6_53K"
    ],
    "SOD1": [
        "SOD1_4K"
    ],
    "SON": [
        "SON_2055K"
    ],
    "SORD": [
        "SORD_134K"
    ],
    "SOX4": [
        "SOX4_286K"
    ],
    "SP1": [
        "SP1_639K",
        "SP1_703K"
    ],
    "SP110": [
        "SP110_394K"
    ],
    "SPAG7": [
        "SPAG7_166K"
    ],
    "SPAG9": [
        "SPAG9_310K"
    ],
    "SPC25": [
        "SPC25_133K",
        "SPC25_21K"
    ],
    "SPCS2": [
        "SPCS2_191K"
    ],
    "SPCS3": [
        "SPCS3_49K"
    ],
    "SPECC1": [
        "SPECC1_145K"
    ],
    "SPTAN1": [
        "SPTAN1_1911K",
        "SPTAN1_2047K",
        "SPTAN1_229K",
        "SPTAN1_2349K",
        "SPTAN1_2452K",
        "SPTAN1_613K",
        "SPTAN1_825K"
    ],
    "SPTBN1": [
        "SPTBN1_1878K",
        "SPTBN1_1981K"
    ],
    "SPTLC1": [
        "SPTLC1_197K"
    ],
    "SPTY2D1": [
        "SPTY2D1_58K",
        "SPTY2D1_63K"
    ],
    "SQOR": [
        "SQOR_365K"
    ],
    "SRBD1": [
        "SRBD1_459K",
        "SRBD1_547K"
    ],
    "SRGAP2": [
        "SRGAP2_470K"
    ],
    "SRP54": [
        "SRP54_120K"
    ],
    "SRP68": [
        "SRP68_164K",
        "SRP68_612K"
    ],
    "SRP72": [
        "SRP72_391K",
        "SRP72_42K",
        "SRP72_504K"
    ],
    "SRPRA": [
        "SRPRA_220K",
        "SRPRA_331K"
    ],
    "SRPRB": [
        "SRPRB_249K"
    ],
    "SRRM1": [
        "SRRM1_659K"
    ],
    "SRRM2": [
        "SRRM2_285K"
    ],
    "SRRT": [
        "SRRT_735K"
    ],
    "SRSF1": [
        "SRSF1_48K"
    ],
    "SRSF10": [
        "SRSF10_218K"
    ],
    "SRSF5": [
        "SRSF5_25K"
    ],
    "SRSF7": [
        "SRSF7_12K",
        "SRSF7_24K",
        "SRSF7_70K"
    ],
    "SRSF9": [
        "SRSF9_46K"
    ],
    "SS18": [
        "SS18_13K"
    ],
    "SS18L1": [
        "SS18L1_13K"
    ],
    "SSB": [
        "SSB_105K",
        "SSB_354K",
        "SSB_76K"
    ],
    "SSBP2": [
        "SSBP2_6K"
    ],
    "SSR2": [
        "SSR2_27K"
    ],
    "SSRP1": [
        "SSRP1_566K",
        "SSRP1_90K"
    ],
    "ST13": [
        "ST13_353K"
    ],
    "STAM2": [
        "STAM2_343K"
    ],
    "STAMBP": [
        "STAMBP_81K"
    ],
    "STARD10": [
        "STARD10_202K"
    ],
    "STARD9": [
        "STARD9_570K"
    ],
    "STAT1": [
        "STAT1_152K",
        "STAT1_296K"
    ],
    "STAT3": [
        "STAT3_370K",
        "STAT3_631K"
    ],
    "STEEP1": [
        "STEEP1_128K"
    ],
    "STIP1": [
        "STIP1_246K",
        "STIP1_317K",
        "STIP1_325K",
        "STIP1_366K",
        "STIP1_373K",
        "STIP1_381K",
        "STIP1_446K",
        "STIP1_462K",
        "STIP1_486K",
        "STIP1_68K"
    ],
    "STMN1": [
        "STMN1_128K",
        "STMN1_52K"
    ],
    "STT3A": [
        "STT3A_610K"
    ],
    "STT3B": [
        "STT3B_10K",
        "STT3B_688K"
    ],
    "STUB1": [
        "STUB1_203K"
    ],
    "SUB1": [
        "SUB1_5K"
    ],
    "SUCLG1": [
        "SUCLG1_57K",
        "SUCLG1_66K",
        "SUCLG1_90K"
    ],
    "SUCLG2": [
        "SUCLG2_139K"
    ],
    "SUGP2": [
        "SUGP2_1035K"
    ],
    "SUMO2": [
        "SUMO2_11K"
    ],
    "SUMO3": [
        "SUMO3_11K",
        "SUMO3_41K"
    ],
    "SUPT16H": [
        "SUPT16H_280K",
        "SUPT16H_366K",
        "SUPT16H_426K",
        "SUPT16H_696K",
        "SUPT16H_781K",
        "SUPT16H_7K"
    ],
    "SUPT5H": [
        "SUPT5H_453K"
    ],
    "SURF4": [
        "SURF4_139K",
        "SURF4_22K"
    ],
    "SYAP1": [
        "SYAP1_254K"
    ],
    "SYNCRIP": [
        "SYNCRIP_100K",
        "SYNCRIP_252K",
        "SYNCRIP_256K",
        "SYNCRIP_91K"
    ],
    "SYNE2": [
        "SYNE2_3575K"
    ],
    "SZRD1": [
        "SZRD1_86K"
    ],
    "TACO1": [
        "TACO1_119K",
        "TACO1_132K"
    ],
    "TADA3": [
        "TADA3_109K",
        "TADA3_124K",
        "TADA3_418K"
    ],
    "TAF1": [
        "TAF1_544K"
    ],
    "TAF15": [
        "TAF15_261K"
    ],
    "TAF3": [
        "TAF3_266K"
    ],
    "TAF9": [
        "TAF9_5K"
    ],
    "TALDO1": [
        "TALDO1_215K",
        "TALDO1_219K",
        "TALDO1_81K"
    ],
    "TAOK3": [
        "TAOK3_738K"
    ],
    "TARBP2": [
        "TARBP2_93K"
    ],
    "TARDBP": [
        "TARDBP_263K"
    ],
    "TARS1": [
        "TARS1_279K",
        "TARS1_583K"
    ],
    "TATDN1": [
        "TATDN1_229K",
        "TATDN1_27K"
    ],
    "TAX1BP1": [
        "TAX1BP1_288K"
    ],
    "TBC1D24": [
        "TBC1D24_312K",
        "TBC1D24_314K",
        "TBC1D24_319K"
    ],
    "TBL3": [
        "TBL3_593K"
    ],
    "TCEA1": [
        "TCEA1_252K"
    ],
    "TCERG1": [
        "TCERG1_1016K",
        "TCERG1_753K"
    ],
    "TCOF1": [
        "TCOF1_155K",
        "TCOF1_367K",
        "TCOF1_716K",
        "TCOF1_746K",
        "TCOF1_918K"
    ],
    "TCP1": [
        "TCP1_111K",
        "TCP1_153K",
        "TCP1_365K",
        "TCP1_400K",
        "TCP1_541K"
    ],
    "TDG": [
        "TDG_248K"
    ],
    "TDRKH": [
        "TDRKH_187K"
    ],
    "TECR": [
        "TECR_57K"
    ],
    "TES": [
        "TES_183K",
        "TES_80K"
    ],
    "TEX10": [
        "TEX10_36K"
    ],
    "TFAP2C": [
        "TFAP2C_440K"
    ],
    "TFIP11": [
        "TFIP11_170K"
    ],
    "TFRC": [
        "TFRC_95K"
    ],
    "THG1L": [
        "THG1L_263K"
    ],
    "THOC1": [
        "THOC1_149K"
    ],
    "THOP1": [
        "THOP1_249K",
        "THOP1_667K"
    ],
    "THRAP3": [
        "THRAP3_455K",
        "THRAP3_519K",
        "THRAP3_558K",
        "THRAP3_688K",
        "THRAP3_876K"
    ],
    "TIMM44": [
        "TIMM44_138K"
    ],
    "TIPRL": [
        "TIPRL_24K"
    ],
    "TJP1": [
        "TJP1_357K"
    ],
    "TKT": [
        "TKT_144K",
        "TKT_204K",
        "TKT_232K",
        "TKT_241K",
        "TKT_260K",
        "TKT_310K",
        "TKT_465K",
        "TKT_6K"
    ],
    "TLE3": [
        "TLE3_309K",
        "TLE3_316K",
        "TLE3_506K"
    ],
    "TLN1": [
        "TLN1_1917K",
        "TLN1_2445K",
        "TLN1_284K"
    ],
    "TM9SF2": [
        "TM9SF2_126K",
        "TM9SF2_423K"
    ],
    "TMA16": [
        "TMA16_169K"
    ],
    "TMED10": [
        "TMED10_133K"
    ],
    "TMED9": [
        "TMED9_226K"
    ],
    "TMEM209": [
        "TMEM209_304K"
    ],
    "TMEM256": [
        "TMEM256_43K"
    ],
    "TMEM43": [
        "TMEM43_159K"
    ],
    "TMLHE": [
        "TMLHE_236K"
    ],
    "TMOD3": [
        "TMOD3_103K",
        "TMOD3_58K"
    ],
    "TMPO": [
        "TMPO_17K",
        "TMPO_281K",
        "TMPO_334K"
    ],
    "TMX3": [
        "TMX3_267K"
    ],
    "TNFAIP8": [
        "TNFAIP8_150K"
    ],
    "TNKS1BP1": [
        "TNKS1BP1_827K"
    ],
    "TNPO1": [
        "TNPO1_81K",
        "TNPO1_869K"
    ],
    "TOM1": [
        "TOM1_106K"
    ],
    "TOM1L1": [
        "TOM1L1_5K"
    ],
    "TOM1L2": [
        "TOM1L2_106K"
    ],
    "TOP1": [
        "TOP1_650K"
    ],
    "TOP2A": [
        "TOP2A_614K"
    ],
    "TOP2B": [
        "TOP2B_208K",
        "TOP2B_367K",
        "TOP2B_407K",
        "TOP2B_471K"
    ],
    "TP53BP1": [
        "TP53BP1_1340K",
        "TP53BP1_1966K"
    ],
    "TPD52L2": [
        "TPD52L2_165K"
    ],
    "TPI1": [
        "TPI1_149K",
        "TPI1_156K",
        "TPI1_175K",
        "TPI1_194K",
        "TPI1_59K",
        "TPI1_6K"
    ],
    "TPM1": [
        "TPM1_152K"
    ],
    "TPM3": [
        "TPM3_153K"
    ],
    "TPM4": [
        "TPM4_11K",
        "TPM4_215K"
    ],
    "TPMT": [
        "TPMT_51K"
    ],
    "TPP2": [
        "TPP2_1110K",
        "TPP2_1204K",
        "TPP2_1216K"
    ],
    "TPR": [
        "TPR_1563K",
        "TPR_1603K",
        "TPR_1648K",
        "TPR_204K",
        "TPR_252K",
        "TPR_290K",
        "TPR_713K",
        "TPR_723K"
    ],
    "TPX2": [
        "TPX2_375K"
    ],
    "TRA2B": [
        "TRA2B_197K",
        "TRA2B_28K"
    ],
    "TRAF2": [
        "TRAF2_207K"
    ],
    "TRAP1": [
        "TRAP1_258K",
        "TRAP1_332K",
        "TRAP1_375K",
        "TRAP1_629K"
    ],
    "TRAPPC11": [
        "TRAPPC11_245K"
    ],
    "TRAPPC5": [
        "TRAPPC5_9K"
    ],
    "TRAPPC9": [
        "TRAPPC9_315K",
        "TRAPPC9_558K"
    ],
    "TRIM25": [
        "TRIM25_345K"
    ],
    "TRIM28": [
        "TRIM28_261K",
        "TRIM28_266K",
        "TRIM28_337K",
        "TRIM28_340K"
    ],
    "TRIM33": [
        "TRIM33_280K",
        "TRIM33_763K",
        "TRIM33_769K",
        "TRIM33_950K",
        "TRIM33_951K",
        "TRIM33_953K"
    ],
    "TRIP12": [
        "TRIP12_1425K"
    ],
    "TRIP13": [
        "TRIP13_185K"
    ],
    "TRIR": [
        "TRIR_128K",
        "TRIR_146K"
    ],
    "TRMT1": [
        "TRMT1_483K",
        "TRMT1_602K"
    ],
    "TRMT5": [
        "TRMT5_108K"
    ],
    "TRPS1": [
        "TRPS1_1192K"
    ],
    "TSN": [
        "TSN_187K",
        "TSN_69K"
    ],
    "TSNAX": [
        "TSNAX_247K",
        "TSNAX_261K"
    ],
    "TSPAN31": [
        "TSPAN31_166K"
    ],
    "TSR1": [
        "TSR1_637K",
        "TSR1_760K"
    ],
    "TSR2": [
        "TSR2_128K"
    ],
    "TTC27": [
        "TTC27_778K"
    ],
    "TTC37": [
        "TTC37_1351K"
    ],
    "TTF2": [
        "TTF2_1031K"
    ],
    "TTN": [
        "TTN_20824K"
    ],
    "TTR": [
        "TTR_96K"
    ],
    "TUBA1B": [
        "TUBA1B_311K",
        "TUBA1B_336K",
        "TUBA1B_394K",
        "TUBA1B_401K",
        "TUBA1B_60K"
    ],
    "TUBB": [
        "TUBB_58K"
    ],
    "TUBB4B": [
        "TUBB4B_58K"
    ],
    "TUBG2": [
        "TUBG2_301K"
    ],
    "TUFM": [
        "TUFM_297K"
    ],
    "TVP23B": [
        "TVP23B_180K"
    ],
    "TWF1": [
        "TWF1_276K"
    ],
    "TXNDC17": [
        "TXNDC17_40K"
    ],
    "TXNDC5": [
        "TXNDC5_118K",
        "TXNDC5_244K"
    ],
    "TXNRD1": [
        "TXNRD1_245K"
    ],
    "TYW5": [
        "TYW5_194K"
    ],
    "U2AF1": [
        "U2AF1_15K"
    ],
    "U2AF2": [
        "U2AF2_70K"
    ],
    "U2SURP": [
        "U2SURP_159K",
        "U2SURP_755K"
    ],
    "UBA1": [
        "UBA1_296K",
        "UBA1_528K",
        "UBA1_980K"
    ],
    "UBA2": [
        "UBA2_245K",
        "UBA2_409K"
    ],
    "UBA3": [
        "UBA3_409K"
    ],
    "UBA6": [
        "UBA6_521K"
    ],
    "UBE2H": [
        "UBE2H_64K"
    ],
    "UBE2K": [
        "UBE2K_18K"
    ],
    "UBE2L3": [
        "UBE2L3_138K",
        "UBE2L3_20K",
        "UBE2L3_73K"
    ],
    "UBE2M": [
        "UBE2M_72K"
    ],
    "UBE2N": [
        "UBE2N_74K",
        "UBE2N_92K"
    ],
    "UBE2O": [
        "UBE2O_217K",
        "UBE2O_521K"
    ],
    "UBE2T": [
        "UBE2T_141K"
    ],
    "UBE2V1": [
        "UBE2V1_10K",
        "UBE2V1_68K"
    ],
    "UBE2V2": [
        "UBE2V2_66K",
        "UBE2V2_8K"
    ],
    "UBE3A": [
        "UBE3A_435K"
    ],
    "UBE3C": [
        "UBE3C_638K"
    ],
    "UBFD1": [
        "UBFD1_224K"
    ],
    "UBR4": [
        "UBR4_1150K",
        "UBR4_3573K",
        "UBR4_4820K"
    ],
    "UBTFL6": [
        "UBTFL6_197K"
    ],
    "UCHL5": [
        "UCHL5_282K"
    ],
    "UFSP2": [
        "UFSP2_36K"
    ],
    "UGDH": [
        "UGDH_100K",
        "UGDH_129K",
        "UGDH_329K"
    ],
    "UGGT1": [
        "UGGT1_306K",
        "UGGT1_362K",
        "UGGT1_930K"
    ],
    "UGGT2": [
        "UGGT2_5K"
    ],
    "UGP2": [
        "UGP2_127K",
        "UGP2_319K",
        "UGP2_52K"
    ],
    "UHRF1": [
        "UHRF1_399K"
    ],
    "UHRF2": [
        "UHRF2_12K"
    ],
    "UNK": [
        "UNK_430K"
    ],
    "UPF1": [
        "UPF1_378K"
    ],
    "UPF2": [
        "UPF2_365K"
    ],
    "UQCRB": [
        "UQCRB_72K"
    ],
    "UQCRC2": [
        "UQCRC2_250K",
        "UQCRC2_92K"
    ],
    "URB1": [
        "URB1_387K"
    ],
    "USP10": [
        "USP10_693K",
        "USP10_722K"
    ],
    "USP14": [
        "USP14_54K"
    ],
    "USP15": [
        "USP15_125K",
        "USP15_154K",
        "USP15_363K"
    ],
    "USP22": [
        "USP22_59K"
    ],
    "USP39": [
        "USP39_459K"
    ],
    "USP5": [
        "USP5_291K",
        "USP5_423K"
    ],
    "USP7": [
        "USP7_209K",
        "USP7_327K",
        "USP7_914K"
    ],
    "USP8": [
        "USP8_34K",
        "USP8_45K"
    ],
    "USP9X": [
        "USP9X_112K",
        "USP9X_315K"
    ],
    "UTP15": [
        "UTP15_80K"
    ],
    "UTP3": [
        "UTP3_144K",
        "UTP3_417K"
    ],
    "UTP4": [
        "UTP4_321K"
    ],
    "UTRN": [
        "UTRN_1739K"
    ],
    "VAC14": [
        "VAC14_761K"
    ],
    "VAMP8": [
        "VAMP8_47K"
    ],
    "VAPA": [
        "VAPA_125K"
    ],
    "VAPB": [
        "VAPB_118K",
        "VAPB_147K",
        "VAPB_167K",
        "VAPB_3K"
    ],
    "VARS1": [
        "VARS1_229K",
        "VARS1_667K",
        "VARS1_952K"
    ],
    "VAV2": [
        "VAV2_718K"
    ],
    "VCL": [
        "VCL_216K",
        "VCL_219K",
        "VCL_426K",
        "VCL_476K",
        "VCL_655K"
    ],
    "VCP": [
        "VCP_236K",
        "VCP_524K"
    ],
    "VDAC1": [
        "VDAC1_12K"
    ],
    "VDAC3": [
        "VDAC3_163K",
        "VDAC3_20K",
        "VDAC3_34K",
        "VDAC3_63K"
    ],
    "VIM": [
        "VIM_120K",
        "VIM_292K",
        "VIM_445K"
    ],
    "VPS35L": [
        "VPS35L_309K"
    ],
    "WAC": [
        "WAC_302K"
    ],
    "WAPL": [
        "WAPL_52K"
    ],
    "WARS1": [
        "WARS1_256K"
    ],
    "WASHC4": [
        "WASHC4_1006K"
    ],
    "WASHC5": [
        "WASHC5_311K"
    ],
    "WBP11": [
        "WBP11_316K"
    ],
    "WDHD1": [
        "WDHD1_941K"
    ],
    "WDR1": [
        "WDR1_321K",
        "WDR1_569K"
    ],
    "WDR12": [
        "WDR12_239K"
    ],
    "WDR33": [
        "WDR33_288K"
    ],
    "WDR36": [
        "WDR36_152K"
    ],
    "WDR43": [
        "WDR43_391K"
    ],
    "WDR48": [
        "WDR48_578K"
    ],
    "WDR5": [
        "WDR5_250K",
        "WDR5_256K"
    ],
    "WDR70": [
        "WDR70_514K"
    ],
    "WDR75": [
        "WDR75_136K",
        "WDR75_466K"
    ],
    "WDR87": [
        "WDR87_2033K"
    ],
    "WIZ": [
        "WIZ_1322K"
    ],
    "WRNIP1": [
        "WRNIP1_301K"
    ],
    "XDH": [
        "XDH_903K"
    ],
    "XPO1": [
        "XPO1_455K",
        "XPO1_563K",
        "XPO1_693K"
    ],
    "XPO4": [
        "XPO4_55K"
    ],
    "XPO7": [
        "XPO7_338K",
        "XPO7_568K"
    ],
    "XPOT": [
        "XPOT_553K",
        "XPOT_950K"
    ],
    "XRCC1": [
        "XRCC1_169K"
    ],
    "XRCC5": [
        "XRCC5_265K",
        "XRCC5_439K",
        "XRCC5_534K"
    ],
    "XRCC6": [
        "XRCC6_317K",
        "XRCC6_556K",
        "XRCC6_565K",
        "XRCC6_591K",
        "XRCC6_605K",
        "XRCC6_94K"
    ],
    "XRN2": [
        "XRN2_368K"
    ],
    "YARS1": [
        "YARS1_146K",
        "YARS1_356K",
        "YARS1_513K"
    ],
    "YARS2": [
        "YARS2_355K"
    ],
    "YBX1": [
        "YBX1_81K"
    ],
    "YEATS4": [
        "YEATS4_212K"
    ],
    "YLPM1": [
        "YLPM1_270K"
    ],
    "YTHDC1": [
        "YTHDC1_90K"
    ],
    "YTHDC2": [
        "YTHDC2_338K"
    ],
    "YTHDF2": [
        "YTHDF2_408K"
    ],
    "YWHAE": [
        "YWHAE_118K",
        "YWHAE_50K"
    ],
    "YWHAG": [
        "YWHAG_69K"
    ],
    "YWHAH": [
        "YWHAH_110K"
    ],
    "YWHAQ": [
        "YWHAQ_122K",
        "YWHAQ_3K",
        "YWHAQ_49K"
    ],
    "YWHAZ": [
        "YWHAZ_122K",
        "YWHAZ_49K"
    ],
    "ZBTB10": [
        "ZBTB10_240K"
    ],
    "ZBTB14": [
        "ZBTB14_284K"
    ],
    "ZBTB4": [
        "ZBTB4_892K"
    ],
    "ZC3H11B": [
        "ZC3H11B_765K"
    ],
    "ZC3H14": [
        "ZC3H14_352K"
    ],
    "ZC3H18": [
        "ZC3H18_651K",
        "ZC3H18_789K"
    ],
    "ZC3HAV1": [
        "ZC3HAV1_122K"
    ],
    "ZCCHC9": [
        "ZCCHC9_50K"
    ],
    "ZFHX3": [
        "ZFHX3_3250K"
    ],
    "ZFP36L2": [
        "ZFP36L2_155K"
    ],
    "ZFR": [
        "ZFR_509K"
    ],
    "ZMAT2": [
        "ZMAT2_8K"
    ],
    "ZMPSTE24": [
        "ZMPSTE24_429K"
    ],
    "ZMYND8": [
        "ZMYND8_413K",
        "ZMYND8_505K"
    ],
    "ZNF148": [
        "ZNF148_342K"
    ],
    "ZNF292": [
        "ZNF292_1117K",
        "ZNF292_816K"
    ],
    "ZNF330": [
        "ZNF330_78K"
    ],
    "ZNF638": [
        "ZNF638_1860K"
    ],
    "ZNF687": [
        "ZNF687_1207K",
        "ZNF687_1216K"
    ],
    "ZNF800": [
        "ZNF800_299K"
    ],
    "ZNHIT1": [
        "ZNHIT1_66K"
    ],
    "ZRSR2P1": [
        "ZRSR2P1_182K"
    ],
    "ZW10": [
        "ZW10_242K"
    ],
    "ZZZ3": [
        "ZZZ3_738K"
    ]
};

export default AllGeneListMatch;